(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1156],{

/***/ 96646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./framework/ui/desktop/header/Breadcrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	justify-content: end;\n	height: 50px;\n	align-items: center;\n\n	li {\n		position: relative;\n		padding-right: 19px;\n		margin-right: 15px;\n		font-size: var(--basic-size);\n		color: var(--gray-color);\n		line-height: 1;\n\n		&:after {\n			position: absolute;\n			top: 5px;\n			right: 0;\n			display: inline-block;\n			width: 5px;\n			height: 5px;\n			border-top: 1px solid var(--default-color);\n			border-left: 1px solid var(--default-color);\n			transform: rotate(135deg);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n\n			&:after {\n				display: none;\n			}\n		}\n\n		a:hover {\n			color: var(--emp-color);\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7f58472-0"
})(_templateObject());
var Breadcrumbs = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: children
    });
};
/* harmony default export */ var header_Breadcrumbs = (Breadcrumbs);

// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/layout/breadcrumbs/desktop/index.tsx










var BreadcrumbLender = function(param) {
    var crumbs = param.crumbs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Breadcrumbs, {
        children: crumbs && crumbs.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.url || "#",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: item.text
                    })
                })
            }, index);
        })
    });
};
var BreadCrumbComponent = function(param) {
    var crumbArray = param.crumbArray, lastCrumb = param.lastCrumb;
    var ref, ref1;
    if (crumbArray) return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbLender, {
        crumbs: crumbArray
    });
    var router = (0,next_router.useRouter)();
    var queryDspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    var dspSid = "".concat(queryDspSid.slice(0, -2), "00");
    var globalMenu = (ref1 = (0,useGlobalMenu/* default */.Z)().data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var menuLv1List = globalMenu.menuLv1List, menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List;
    var menuList = (0,_to_consumable_array/* default */.Z)(menuLv1List).concat((0,_to_consumable_array/* default */.Z)(menuLv2List), (0,_to_consumable_array/* default */.Z)(menuLv3List));
    var crumbs = (0,react.useMemo)(function() {
        var result = [];
        if (!menuList) return result;
        var lv3 = menuList.find(function(v) {
            return v.dspSid === dspSid;
        });
        if (!lv3 || lv3.lv !== 3) return result;
        var lv2 = menuList.find(function(v) {
            return v.dspSid === lv3.dspSidHi;
        });
        var lv1 = menuList.find(function(v) {
            return v.dspSid === lv2.dspSidHi;
        });
        result.push({
            text: "홈",
            url: config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL
        });
        lv1 && result.push({
            text: lv1.dspNm,
            url: lv1.dspUrl || ""
        });
        lv2 && result.push({
            text: lv2.dspNm,
            url: lv2.dspUrl || ""
        });
        result.push({
            text: lv3.dspNm,
            url: lv3.dspUrl || ""
        });
        // 마지막 Crumb가 있는 경우 추가
        if (lastCrumb) result.push(lastCrumb);
        return result;
    }, [
        globalMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbLender, {
        crumbs: crumbs
    });
};
var Breadcrumb = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Breadcrumb Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop = (Breadcrumb);


/***/ }),

/***/ 19145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Desktop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./framework/ui/desktop/footer/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	width: 100%;\n	padding-bottom: 40px;\n	background: #fff;\n	div {\n		width: 1200px;\n		margin: auto;\n		article {\n			flex-shrink: 0;\n			box-sizing: border-box;\n		}\n	}\n	nav {\n		border-top: 1px solid #ddd;\n		border-bottom: 1px solid #ddd;\n		background-color: #f5f5f5;\n		box-sizing: border-box;\n		a {\n			line-height: 1.6;\n			font-size: 15px;\n			color: #111;\n			font-family: "pr-font-medium";\n		}\n		div {\n			display: flex;\n			align-items: center;\n			justify-content: space-between;\n			height: 60px;\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	nav {\n		ul {\n			display: flex;\n			gap: 30px;\n		}\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	div {\n		display: flex;\n		margin: 60px auto;\n		article:first-child {\n			width: 470px;\n			border-right: 1px solid #ddd;\n			font-size: 16px;\n			color: #555;\n			> p {\n				line-height: 1;\n				letter-spacing: -0.025em;\n				font-size: 28px;\n				font-family: "pr-font-medium";\n				color: #111;\n			}\n			dl {\n				display: flex;\n				gap: 20px;\n				line-height: 1;\n				margin: 30px 0;\n				dt {\n					font-family: "pr-font-medium";\n					color: #111;\n				}\n			}\n			ul li {\n				position: relative;\n				line-height: 1;\n				padding-left: 10px;\n				+ li {\n					margin-top: 20px;\n				}\n				&:before {\n					position: absolute;\n					top: 10px;\n					left: 0;\n					display: block;\n					width: 2px;\n					height: 2px;\n					background: #999;\n					content: "";\n				}\n				p {\n					line-height: 1.6;\n				}\n			}\n		}\n		article:nth-child(2) {\n			padding: 0 25px 0 60px;\n			ul {\n				display: flex;\n				gap: 40px;\n				li {\n					display: flex;\n					flex-direction: column;\n					align-items: center;\n					justify-content: flex-start;\n					gap: 20px;\n					width: 190px;\n					> p {\n						line-height: 1;\n						font-size: 20px;\n						letter-spacing: -0.025em;\n						em {\n							line-height: 1;\n							font-size: 26px;\n							font-family: "pr-font-medium";\n							color: #111;\n							letter-spacing: 0;\n						}\n					}\n					> button {\n						height: 40px;\n						line-height: 1;\n						padding: 12px 20px;\n						border: 1px solid #555;\n						background-color: #fff;\n						border-radius: 4px;\n						font-size: 14px;\n						font-family: "pr-font-medium";\n						color: #111;\n						white-space: nowrap;\n						box-sizing: border-box;\n						cursor: pointer;\n					}\n					&::before {\n						display: block;\n						width: 30px;\n						height: 30px;\n						margin-bottom: 5px;\n						background-repeat: no-repeat;\n						background-position: center;\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_pkg.png);\n						content: "";\n					}\n					&:nth-child(2):before {\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_air.png);\n					}\n					&:last-child:before {\n						background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/ico_cs_region.png);\n					}\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	nav {\n		height: 60px;\n		background-color: #fff;\n		box-sizing: border-box;\n		ul:first-child {\n			display: flex;\n			gap: 30px;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	a {\n		display: block;\n		width: 34px;\n		height: 34px;\n		&:before {\n			position: absolute;\n			display: block;\n			width: 34px;\n			height: 34px;\n			border-radius: 50%;\n			background: #fff url(https://cimgcdn.ybtour.co.kr/common/footer/btn_sns.png) no-repeat;\n			content: " ";\n			background-position: ',
        ";\n		}\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	li {\n		&:nth-child(2) > a em {\n			color: #4567ad;\n			font-family: "pr-font-medium";\n		}\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 40px auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	article:first-child {\n		position: relative;\n		width: 780px;\n		border-right: 1px solid #ddd;\n		h5 {\n			line-height: 1;\n			margin: 0 0 30px 0;\n			font-size: 15px;\n			font-family: "pr-font-bold";\n			color: #222;\n		}\n		img {\n			width: 130px;\n			height: 10px;\n			margin-left: 20px;\n			vertical-align: baseline;\n		}\n		address {\n			font-size: 12px;\n			line-height: 1.8;\n			color: #777;\n			+ address {\n				margin-top: 10px;\n			}\n			+ span {\n				margin-top: 20px;\n			}\n		}\n		span {\n			display: block;\n			margin: 0;\n			font-size: 12px;\n			font-style: normal;\n			line-height: 1.8;\n			color: #777;\n		}\n		> a {\n			margin-left: 10px;\n			font-size: 12px;\n			text-decoration: underline;\n			color: #555;\n		}\n		i {\n			font-style: normal;\n			&:after {\n				display: inline-block;\n				width: 1px;\n				height: 10px;\n				margin: 0 6px 0 8px;\n				background: #999;\n				content: " ";\n			}\n		}\n	}\n	article:last-child {\n		width: 430px;\n		padding-left: 40px;\n		> a {\n			position: relative;\n			line-height: 1;\n			margin-right: 12px;\n			font-family: "pr-font-medium";\n			color: #111;\n			font-size: 14px;\n			&:after {\n				position: absolute;\n				top: 50%;\n				left: 100%;\n				width: 5px;\n				height: 5px;\n				margin: -3px 0 0 5px;\n				border-top: 1px solid #111;\n				border-right: 1px solid #111;\n				transform: rotate(45deg);\n				content: " ";\n			}\n		}\n		span {\n			display: flex;\n			flex-wrap: wrap;\n			justify-content: space-between;\n			gap: 10px;\n			width: 390px;\n			margin: 20px 0 25px;\n			font-size: 13px;\n		}\n		dl {\n			display: flex;\n			gap: 10px;\n			line-height: 1;\n			dt {\n				min-width: 98px;\n				color: #555;\n			}\n			dd {\n				min-width: 80px;\n				color: #111;\n				font-family: "pr-font-medium";\n			}\n			&:nth-child(2) {\n				dt {\n					min-width: 78px;\n				}\n			}\n		}\n		span + ul {\n			display: contents;\n			font-size: 12px;\n			color: #777;\n			li {\n				display: flex;\n				width: 100%;\n				margin: 0;\n				line-height: 1.8;\n				em {\n					width: 60px;\n				}\n				a {\n					width: 310px;\n					text-decoration: underline;\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	height: 60px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	height: 60px;\n	&:nth-child(1) button,\n	&:nth-child(2) button {\n		width: 165px;\n		&::before {\n			width: 165px;\n		}\n	}\n	button {\n		position: relative;\n		width: 162px;\n		height: 60px;\n		padding: 0;\n		border: 0;\n		background-color: transparent;\n		text-indent: 0;\n		cursor: pointer;\n		overflow: visible;\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n		&:before {\n			display: block;\n			height: 60px;\n			background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/btn_award_202503.png);\n			background-position: 0 0;\n			background-repeat: no-repeat;\n			content: "";\n			background-position: ',
        ";\n		}\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	ul {\n		display: flex;\n		flex-direction: column;\n		align-items: flex-start;\n		height: auto;\n		margin: 20px 0 30px;\n		li {\n			position: relative;\n			padding-left: 7px;\n			font-size: 12px;\n			color: #777;\n			&:before {\n				position: absolute;\n				top: 6px;\n				left: 0;\n				display: block;\n				width: 2px;\n				height: 2px;\n				background: #999;\n				content: " ";\n			}\n			+ li {\n				margin-top: 10px;\n			}\n		}\n	}\n	+ p {\n		line-height: 1.8;\n		font-size: 12px;\n		color: #777;\n	}\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	right: 20px;\n	bottom: 40px;\n	z-index: 100;\n	width: 60px;\n	height: 60px;\n\n	button > span {\n		font-size: 0;\n		color: transparent;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	right: 20px;\n	bottom: 40px;\n	z-index: 100;\n	transition: bottom 0.4s;\n	",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	z-index: 105;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 4px;\n	width: 60px;\n	height: 60px;\n	border-radius: 50%;\n	background-color: #ffce3c;\n	font-size: 14px;\n	color: var(--gray-color);\n	cursor: pointer;\n\n	&:before {\n		display: block;\n		width: 20px;\n		height: 22px;\n		background-image: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_chatbot.png);\n		background-repeat: no-repeat;\n		background-size: contain;\n		content: "";\n	}\n	&:after {\n		display: inline-block;\n		content: "상담";\n		font-family: "pr-font-bold";\n		font-size: 14px;\n		letter-spacing: -0.025em;\n		color: #111;\n	}\n	+ div {\n		position: absolute;\n		top: 0;\n		right: 30px;\n		z-index: 100;\n		display: flex;\n		justify-content: center;\n		align-items: center;\n		width: 0;\n		height: 60px;\n		padding: 0;\n		border-radius: 100px 0 0 100px;\n		background: #555;\n		overflow: hidden;\n		box-sizing: border-box;\n		opacity: 0;\n		transition: all 0.4s;\n\n		> span {\n			color: #fff;\n			font-size: 15px;\n			letter-spacing: -0.025em;\n			white-space: nowrap;\n		}\n	}\n	&:hover + div {\n		width: 245px;\n		padding: 0 45px 0 30px;\n		opacity: 1;\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	width: 60px;\n	height: 60px;\n	margin-bottom: -1px;\n	border: 1px solid var(--line-color);\n	border-radius: 50%;\n	background-color: #fff;\n	font-size: 14px;\n	color: var(--gray-color);\n	opacity: 0;\n	animation: fadeout 0.4s;\n	cursor: pointer;\n	:hover,\n	:active {\n		background-color: #111;\n		:before {\n			border-color: #fff;\n		}\n		:after {\n			background-color: #fff;\n		}\n	}\n	:before {\n		position: absolute;\n		top: 20px;\n		left: 50%;\n		display: block;\n		width: 12px;\n		height: 12px;\n		margin: 0 0 0 -6px;\n		border-top: 2px solid #111;\n		border-right: 2px solid #111;\n		transform: rotate(-45deg);\n		content: "";\n	}\n	:after {\n		position: absolute;\n		display: block;\n		top: 20px;\n		left: 50%;\n		width: 2px;\n		height: 20px;\n		background-color: #111;\n		content: "";\n	}\n\n	',
        "\n\n	@keyframes fadein {\n		0% {\n			opacity: 0;\n		}\n		100% {\n			opacity: 1;\n		}\n	}\n	@keyframes fadeout {\n		0% {\n			opacity: 1;\n		}\n		100% {\n			opacity: 0;\n		}\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 0;\n	right: 40px;\n	display: flex;\n	gap: 15px;\n	li {\n		&:nth-child(2) {\n			a {\n				&::before {\n					width: 60px;\n					background-position: -65px 0;\n				}\n			}\n		}\n		a {\n			display: block;\n			width: 100%;\n			height: 100%;\n			&::before {\n				display: block;\n				width: 65px;\n				height: 56px;\n				background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/logo_franchise.png);\n				background-size: auto 56px;\n				background-position: 0 0;\n				background-repeat: no-repeat;\n				content: "";\n			}\n		}\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var FooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-0"
})(_templateObject());
var Fnb = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c2eea534-1"
})(_templateObject1());
var CsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-2"
})(_templateObject2());
var LinkWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c2eea534-3"
})(_templateObject3());
var Sns = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c2eea534-4"
})(_templateObject4());
var SnsItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-c2eea534-5"
})(_templateObject5(), function(props) {
    if (props.$sns === "facebook") {
        return "\n                0 0;\n            ";
    }
    if (props.$sns === "instagram") {
        return "\n				-34px 0;\n            ";
    }
    if (props.$sns === "youtube") {
        return "\n				-68px 0;\n            ";
    }
    if (props.$sns === "kakao") {
        return "\n				-102px 0;\n            ";
    }
    if (props.$sns === "blog") {
        return "\n				-136px 0;\n            ";
    }
    if (props.$sns === "post") {
        return "\n				-170px 0;\n            ";
    }
});
var Policies = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c2eea534-6"
})(_templateObject6());
var CompanyInfo = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c2eea534-7"
})(_templateObject7());
var Corporation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-8"
})(_templateObject8());
var AwardList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c2eea534-9"
})(_templateObject9());
var AwardListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-c2eea534-10"
})(_templateObject10(), function(props) {
    if (props.$award === "ccm") {
        return "0 0";
    }
    if (props.$award === "ftc") {
        return "-175px 0";
    }
    if (props.$award === "ccm2023") {
        return "-350px 0";
    }
    if (props.$award === "knqa") {
        return "-522px 0";
    }
    if (props.$award === "scsi") {
        return "-694px 0";
    }
    if (props.$award === "icsi") {
        return "-866px 0";
    }
    if (props.$award === "isms") {
        return "-1038px 0";
    }
});
var CopyrightWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-11"
})(_templateObject11());
var FloatingBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-12"
})(_templateObject12());
var TalkWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c2eea534-13"
})(_templateObject13(), function(props) {
    return props.$show && "\n		bottom: 110px;\n	";
});
var TalkBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c2eea534-14"
})(_templateObject14());
var TopButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c2eea534-15"
})(_templateObject15(), function(props) {
    return props.$show && "\n			opacity: 1;\n			animation: fadein 0.4s;\n	";
});
var LogoList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c2eea534-16"
})(_templateObject16());
var Footer = function() {
    var router = useRouter();
    var ref = useState(false), topShow = ref[0], setTopShow = ref[1];
    var ref1 = useState(0), lastScrollTop = ref1[0], setLastScrollTop = ref1[1];
    var handleScroll = function() {
        var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
        if (currentScrollTop > lastScrollTop) {
            setTopShow(false);
        } else {
            setTopShow(true);
        }
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };
    var onClickAward = function(value) {
        window.open("https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html".concat(value ? "#award=".concat(value) : ""), "popupWindow", "width=600,height=720,left=200,top=200");
    };
    var top = useCallback(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    useEffect(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        lastScrollTop,
        router
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FooterWrap, {
                className: "footer",
                children: [
                    /*#__PURE__*/ _jsx(Fnb, {
                        children: /*#__PURE__*/ _jsx("nav", {
                            children: /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsxs("ul", {
                                    children: [
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                children: "고객센터"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/noticeList.yb",
                                                children: "공지사항"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/faqList.yb",
                                                children: "자주하는질문"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/qnaGuide.yb",
                                                children: "1:1문의"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/estimateWrite.yb",
                                                children: "견적문의"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/eplg/episodeList.yb",
                                                children: "여행후기"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/praiseList.yb",
                                                children: "칭찬합시다"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/freeInstallmentPopup.yb",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "무이자할부"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=",
                                                target: "_self",
                                                children: "현금영수증"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(CsWrap, {
                        children: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "노랑풍선 고객센터"
                                        }),
                                        /*#__PURE__*/ _jsxs("dl", {
                                            children: [
                                                /*#__PURE__*/ _jsx("dt", {
                                                    children: "상담시간"
                                                }),
                                                /*#__PURE__*/ _jsx("dd", {
                                                    children: "평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            "해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:",
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            "평일 오후 5시까지"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("p", {
                                                        children: "호텔 취소/변경/환불: 평일 오후 4시까지"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("article", {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "패키지여행 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "1544-2288"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        onClick: function() {
                                                            window.open("https://pkg.ybtour.co.kr/cs/arsGuide.yb");
                                                        },
                                                        children: "지역별 직통 상담번호 안내"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "자유여행 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "1644-3399"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "부산/지방출발 상담"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: /*#__PURE__*/ _jsx("em", {
                                                            children: "051-713-0710"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(LinkWrap, {
                        children: /*#__PURE__*/ _jsx("nav", {
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs(Policies, {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "http://company.ybtour.co.kr/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "회사소개"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/privacy.yb",
                                                    children: /*#__PURE__*/ _jsx("em", {
                                                        children: "개인정보처리방침"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/internetAgree.yb",
                                                    children: "이용약관"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/travelAgree.yb",
                                                    children: "여행약관"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/common/travelerInsuInfo.yb",
                                                    children: "여행자보험"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "http://company.ybtour.co.kr/agent/about",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "대리점안내"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/directionGuide.yb",
                                                    children: "오시는 길"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Sns, {
                                        children: [
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "facebook",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.facebook.com/yellowballoonofficial/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 페이스북 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "instagram",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.instagram.com/yellowballoon_official/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 인스타 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "youtube",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.youtube.com/user/ybtour2013",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 유튜브 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "kakao",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pf.kakao.com/_hhAxbd",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 플러스친구 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(SnsItem, {
                                                $sns: "blog",
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://blog.naver.com/yb_tour",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "노랑풍선 네이버블로그 바로가기"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(CompanyInfo, {
                        children: /*#__PURE__*/ _jsxs(Corporation, {
                            children: [
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("h5", {
                                            children: [
                                                "(주)노랑풍선",
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                                    alt: "코스닥상장법인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            children: [
                                                "대표이사 김진국",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "서울특별시 중구 수표로31, 노랑풍선빌딩",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "사업자등록번호 104-81-64440 ",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "관광사업자등록증번호 제2006-000003호",
                                                /*#__PURE__*/ _jsx("i", {}),
                                                "통신판매업신고번호 제2008-서울중구-0278",
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "사업자 정보확인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            children: [
                                                "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "사업자등록번호 870-85-01900"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "영업배상책임보험가입 총 20억원 \xb7 한국관광협회중앙회 여행공제회 공제영업보증가입 10억원 \xb7 공제기획여행보증가입 5억원"
                                        }),
                                        /*#__PURE__*/ _jsxs(LogoList, {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: "http://tourinfo.or.kr/standard/partners.asp",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: "https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd= ",
                                                        target: "_self",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "현금영수증 의무발행 가맹점"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("article", {
                                    children: [
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "1544-2288"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "1644-3399"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("dl", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("dt", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("dd", {
                                                            children: "051-713-0710"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "대표메일"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:master@ybtour.com",
                                                            children: "master@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "판매제휴"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:salespartner@ybtour.com",
                                                            children: "salespartner@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "마케팅제휴"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:marketing@ybtour.com",
                                                            children: "marketing@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("em", {
                                                            children: "대리점문의"
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "mailto:sales.agent@ybtour.co.kr",
                                                            children: "sales.agent@ybtour.co.kr"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        children: /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs(AwardList, {
                                    children: [
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ccm",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award1");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 공정거래위원회 한국소비자원"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ftc",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award2");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 국무총리 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "ccm2023",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award3");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "소비자중심경영 공정거래위원장 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "knqa",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award4");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "제45회 국가품질경영대회서비스품질우수상"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "scsi",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "SCSI 대한민국 소셜미디어대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "icsi",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "ICSI 대한민국 인터넷소통대상 기업부문 대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(AwardListItem, {
                                            $award: "isms",
                                            children: /*#__PURE__*/ _jsx("button", {
                                                onClick: function() {
                                                    return onClickAward("award6");
                                                },
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "정보보호 관리체계 인증"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(CopyrightWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: "\xa9 Yellow Balloon tour. All Rights Reserved."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FloatingBlock, {
                children: /*#__PURE__*/ _jsx(TopButton, {
                    $show: topShow,
                    onClick: top,
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "최상단 이동"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var footer = ((/* unused pure expression or super */ null && (Footer)));


// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts + 43 modules
var useConfigureAxios = __webpack_require__(21741);
;// CONCATENATED MODULE: ./components/layout/footer/Desktop/index.tsx







var Desktop_Footer = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), topShow = ref[0], setTopShow = ref[1];
    var ref1 = (0,react.useState)(0), lastScrollTop = ref1[0], setLastScrollTop = ref1[1];
    var handleScroll = function() {
        var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
        if (currentScrollTop > lastScrollTop) {
            setTopShow(false);
        } else {
            setTopShow(true);
        }
        setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };
    var onClickAward = function(value) {
        window.open("https://www.ybtour.co.kr/assets/main/desktop/webcontent/awards_popup.html".concat(value ? "#award=".concat(value) : ""), "popupWindow", "width=600,height=720,left=200,top=200");
    };
    var top = (0,react.useCallback)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        lastScrollTop,
        router
    ]);
    /** 해피톡 */ var ref2 = (0,react.useState)(false), isTalk = ref2[0], setIsTalk = ref2[1];
    (0,react.useEffect)(function() {
        if (!router.query.dspSid || !router.pathname.includes("/product/localList")) return;
        useConfigureAxios/* default.get */.Z.get("".concat(config_public/* default.ENV_SUPPORT_URL */.Z.ENV_SUPPORT_URL, "/api/bff/menu/list")).then(function(res) {
            var body = res.data.body;
            var target = body.menuLv3List.find(function(v) {
                return v.dspSid === router.query.dspSid;
            });
            if ((target === null || target === void 0 ? void 0 : target.talkYn) === "Y") setIsTalk(true);
        });
    }, [
        router.pathname,
        router.query.dspSid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrap, {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fnb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                                children: "고객센터"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeList.yb"),
                                                children: "공지사항"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/faqList.yb"),
                                                children: "자주하는질문"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/qnaGuide.yb"),
                                                children: "1:1문의"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/estimateWrite.yb"),
                                                children: "견적문의"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/eplg/episodeList.yb"),
                                                children: "여행후기"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/praiseList.yb"),
                                                children: "칭찬합시다"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/freeInstallmentPopup.yb"),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "무이자할부"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                                target: "_self",
                                                children: "현금영수증"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "노랑풍선 고객센터"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: "상담시간"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    children: "평일 오전 9시 ~ 오후 6시 (토,일요일 및 공휴일 휴무)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "해외항공권 변경, 투어&티켓, 렌터카 취소/변경/환불:",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "평일 오후 5시까지"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "호텔 취소/변경/환불: 평일 오후 4시까지"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "패키지여행 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "1544-2288"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            window.open("".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/arsGuide.yb"));
                                                        },
                                                        children: "지역별 직통 상담번호 안내"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "자유여행 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "1644-3399"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "부산/지방출발 상담"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "051-713-0710"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Policies, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "회사소개"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/privacy.yb"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: "개인정보처리방침"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/internetAgree.yb"),
                                                    children: "이용약관"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/travelAgree.yb"),
                                                    children: "여행약관"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/travelerInsuInfo.yb"),
                                                    children: "여행자보험"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL, "/agent/about"),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "대리점안내"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/directionGuide.yb"),
                                                    children: "오시는 길"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sns, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "facebook",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.facebook.com/yellowballoonofficial/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 페이스북 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "instagram",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.instagram.com/yellowballoon_official/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 인스타 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "youtube",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.youtube.com/user/ybtour2013",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 유튜브 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "kakao",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://pf.kakao.com/_hhAxbd",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 플러스친구 바로가기"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                                $sns: "blog",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://blog.naver.com/yb_tour",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "노랑풍선 네이버블로그 바로가기"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Corporation, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            children: [
                                                "(주)노랑풍선",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                                    alt: "코스닥상장법인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                            children: [
                                                "대표이사 김진국",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "서울특별시 중구 수표로31, 노랑풍선빌딩",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "사업자등록번호 104-81-64440 ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "관광사업자등록증번호 제2006-000003호",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {}),
                                                "통신판매업신고번호 제2008-서울중구-0278",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "사업자 정보확인"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                            children: [
                                                "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 (부전동, 에이원프라자)",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "사업자등록번호 870-85-01900"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "영업배상책임보험가입 총 20억원 \xb7 한국관광협회중앙회 여행공제회 공제영업보증가입 10억원 \xb7 공제기획여행보증가입 5억원"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoList, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "http://tourinfo.or.kr/standard/partners.asp",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                                        target: "_self",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "현금영수증 의무발행 가맹점"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "1544-2288"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "1644-3399"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                            children: "051-713-0710"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "대표메일"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:master@ybtour.com",
                                                            children: "master@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "판매제휴"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:salespartner@ybtour.com",
                                                            children: "salespartner@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "마케팅제휴"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:marketing@ybtour.com",
                                                            children: "marketing@ybtour.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "대리점문의"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:sales.agent@ybtour.co.kr",
                                                            children: "sales.agent@ybtour.co.kr"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AwardList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ccm",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award1");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 공정거래위원회 한국소비자원"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ftc",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award2");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 국무총리 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "ccm2023",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award3");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "소비자중심경영 공정거래위원장 표창"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "knqa",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award4");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "제45회 국가품질경영대회서비스품질우수상"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "scsi",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "SCSI 대한민국 소셜미디어대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "icsi",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award5");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "ICSI 대한민국 인터넷소통대상 기업부문 대상 1위"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AwardListItem, {
                                            $award: "isms",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return onClickAward("award6");
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "정보보호 관리체계 인증"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "\xa9 Yellow Balloon tour. All Rights Reserved."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingBlock, {
                children: [
                    isTalk && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalkWrap, {
                        $show: topShow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalkBtn, {
                                onClick: commonUtil/* openTalk */.Vt,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "해피톡 상담"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "허니문 채팅상담 서비스입니다."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopButton, {
                        $show: topShow,
                        onClick: top,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "최상단 이동"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Desktop = (Desktop_Footer);


/***/ }),

/***/ 2370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Desktop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./public/P/images/ico/ico_prod.png
var ico_prod = __webpack_require__(15196);
var ico_prod_default = /*#__PURE__*/__webpack_require__.n(ico_prod);
;// CONCATENATED MODULE: ./components/style/common/history.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	z-index: 101;\n	width: 100%;\n	height: 100%;\n\n	",
        "\n	",
        "\n\n	\n	@keyframes dimmfadein {\n		from {\n			opacity: 0;\n			height: 100%;\n		}\n\n		to {\n			opacity: 1;\n		}\n	}\n	@keyframes dimmfadeout {\n		from {\n			opacity: 1;\n		}\n\n		to {\n			opacity: 0;\n		}\n	}\n\n	@keyframes slidein {\n		from {\n			transform: translate3d(100%, 0, 0);\n		}\n\n		to {\n			transform: translate3d(0, 0, 0);\n		}\n	}\n	@keyframes slideout {\n		from {\n			transform: translate3d(0, 0, 0);\n		}\n\n		to {\n			transform: translate3d(100%, 0, 0);\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	right: 0;\n	left: 0;\n	bottom: 0;\n	z-index: 100;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	opacity: 0;\n	transition: opacity 0.3s;\n	will-change: opacity;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	bottom: 0;\n	right: 0;\n	z-index: 100;\n	display: flex;\n	flex-direction: column;\n	width: 400px;\n	height: 100%;\n	margin: 0;\n	background: #fff;\n	transform: translate3d(100%, 0, 0);\n	transition: transform 0.3s;\n	transition-timing-function: ease-in-out;\n	will-change: transform;\n	box-sizing: border-box;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	align-items: center;\n	flex: 0 0 70px;\n	margin: 0 20px;\n	border-bottom: 1px solid #222;\n	box-sizing: border-box;\n	> div {\n		display: flex;\n		align-items: center;\n		gap: 15px;\n		> button:first-of-type {\n			min-width: 80px;\n			+ button {\n				margin: 0;\n			}\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	height: calc(100% - 70px);\n	overflow-x: hidden;\n	overflow-y: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 100%;\n	height: 100%;\n	text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: -webkit-box;\n	padding-right: 30px;\n	font-size: 22px;\n	color: var(--emp-color);\n	letter-spacing: 0;\n	font-family: "pr-font-medium";\n	overflow: hidden;\n	text-overflow: ellipsis;\n	white-space: normal;\n	word-wrap: break-word;\n	word-break: break-all;\n	-webkit-line-clamp: 1;\n	-webkit-box-orient: vertical;\n	line-clamp: 1;\n\n	> span {\n		margin-left: 10px;\n		font-size: 16px;\n		font-weight: normal;\n		color: var(--blue-color);\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	flex: 0 0 80px;\n	width: 100%;\n	height: 80px;\n	padding: 0 20px;\n	box-sizing: border-box;\n	color: var(--emp-color);\n	> span {\n		font-size: 14px;\n	}\n	> button {\n		background: #fff;\n		font-size: 14px;\n		text-decoration: underline;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	padding: 0 20px;\n\n	> li {\n		flex: 0 0 auto;\n		margin-top: -5px;\n	}\n\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 24px;\n		z-index: 1;\n		display: block;\n		width: 2px;\n		height: 100%;\n		background: #ddd;\n		content: "";\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 20px;\n	margin-bottom: 30px;\n	color: #222;\n	&:before {\n		position: absolute;\n		top: 3px;\n		left: 0;\n		z-index: 2;\n		display: inline-block;\n		width: 11px;\n		height: 11px;\n		border-radius: 50%;\n		background: #222;\n		content: "";\n	}\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-left: 20px;\n	margin-bottom: 30px;\n\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 20px;\n	overflow: hidden;\n	cursor: pointer;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 16px;\n	height: 12px;\n	margin-right: 5px;\n	background: url(",
        ") no-repeat -249px 0;\n	background-size: 400px 400px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 20px;\n	width: calc(100% - 20px);\n	height: 100%;\n	cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	justify-content: space-between;\n	> div {\n		position: absolute;\n		top: 0;\n		right: 0;\n		z-index: 1;\n		display: flex;\n		align-items: center;\n		gap: 20px;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	width: 12px;\n	height: 12px;\n	background: transparent;\n	&:before {\n		position: absolute;\n		top: 0;\n		left: 50%;\n		display: block;\n		width: 1px;\n		height: 12px;\n		background: #7b7b7b;\n		transform: rotate(-45deg) translateX(-50%);\n		content: "";\n	}\n	&:after {\n		position: absolute;\n		top: 0;\n		right: 50%;\n		display: block;\n		width: 1px;\n		height: 12px;\n		background: #7b7b7b;\n		transform: rotate(-135deg) translateX(-50%);\n		content: "";\n	}\n	> span {\n		font-size: 0;\n		text-indent: -9999em;\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				display: flex;\n				align-items: center;\n				justify-content: center;\n				background: #f3f3f3;\n				&::before {\n					display: block;\n					z-index: 1;\n					width: 63px;\n					height: 50px;\n					background: #f3f3f3 url(",
        ') no-repeat 0 0;\n					background-size: auto 50px;\n					content: "";\n				}\n			'
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				display: flex;\n				align-items: center;\n				justify-content: center;\n				background: #f3f3f3;\n				&::before {\n					display: block;\n					z-index: 1;\n					width: 67px;\n					height: 50px;\n					background: #f3f3f3 url(",
        ') no-repeat -63px 0;\n					background-size: auto 50px;\n					content: "";\n				}\n			'
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	flex: 0 0 auto;\n	width: 120px;\n	height: 80px;\n	overflow: hidden;\n\n	",
        "\n\n	img {\n		width: 120px;\n		height: 80px;\n		object-fit: cover;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	flex: 1 1 auto;\n	width: 200px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 20px;\n	z-index: 4;\n	display: none;\n	flex-direction: column;\n	align-items: center;\n	justify-content: center;\n	gap: 10px;\n	width: calc(100% - 20px);\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	color: #fff;\n\n	> div {\n		display: flex;\n		gap: 8px;\n\n		> button {\n			width: 100px;\n			padding: 10px 0;\n			border: 1px solid #fff;\n			background: transparent;\n			color: #fff;\n		}\n	}\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: -webkit-box;\n	width: 180px;\n	height: 44px;\n	line-height: 22px;\n	margin-top: 10px;\n	font-size: 15px;\n	color: var(--emp-color);\n	overflow: hidden;\n	text-overflow: ellipsis;\n	-webkit-line-clamp: 2;\n	-webkit-box-orient: vertical;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	margin-top: 20px;\n	gap: 7px;\n\n	> span {\n		font-size: 14px;\n		color: #555;\n	}\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-flex;\n	align-items: center;\n	gap: 5px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n			dt {\n				padding-right: 0;\n				&:after {\n					display: inline-block;\n					width: 1px;\n					height: 10px;\n					margin-left: 10px;\n					background-color: #ddd;\n					content: "";\n				}\n			}\n			dd {\n				margin-left: 10px;\n			}\n		'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	text-align: left;\n	line-height: 1.2;\n	font-size: 14px;\n\n	dt {\n		position: relative;\n		display: inline-flex;\n		align-items: center;\n		flex: 0 0 auto;\n		padding-right: 10px;\n		color: #222;\n		vertical-align: middle;\n	}\n	dd {\n		display: inline-block;\n		color: #555;\n		vertical-align: middle;\n	}\n\n	",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	flex: 0 0 100px;\n	> button {\n		min-width: 140px;\n	}\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}



var PopupContainer = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-9744d673-0"
})(_templateObject(), function(props) {
    return props.open ? "\n		display: block;\n		" : "\n		display: none;\n		";
}, function(props) {
    return props.show ? "\n	\n	> div {\n			&:first-of-type{\n				\n				animation: dimmfadein 0.3s forwards;\n				display: block;\n			}\n			&:last-of-type{\n				animation: slidein 0.3s 0.3s forwards;\n			}\n	" : "\n			> div {\n			&:first-of-type{\n				animation: dimmfadeout 0.3s forwards;\n			}\n			&:last-of-type{\n				animation: slideout 0.3s forwards;\n			}\n	";
});
var PopupDimm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-1"
})(_templateObject1());
var PopupBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-2"
})(_templateObject2());
var PopupTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-3"
})(_templateObject3());
var PopupArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-4"
})(_templateObject4());
var TxtEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-5"
})(_templateObject5());
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-9744d673-6"
})(_templateObject6());
var TopArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-7"
})(_templateObject7());
var HistoryList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9744d673-8"
})(_templateObject8());
var TitDate = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9744d673-9"
})(_templateObject9());
var ProdList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9744d673-10"
})(_templateObject10());
var ProdListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9744d673-11"
})(_templateObject11(), function(props) {
    return props.soldout && "\n		> div:first-of-type {\n			display: flex;\n		}\n	";
});
var Prod = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-12"
})(_templateObject12());
var ArrowIcon = styled_components_browser_esm/* default.i.withConfig */.ZP.i.withConfig({
    componentId: "sc-9744d673-13"
})(_templateObject13(), (ico_spr_default()));
var ProdData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-14"
})(_templateObject14());
var ContainerTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-15"
})(_templateObject15());
var ProdDeleteBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9744d673-16"
})(_templateObject16());
var ThumbImg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9744d673-17"
})(_templateObject19(), function(props) {
    if (props.types === "rent") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject17(), (ico_prod_default()));
    }
    if (props.types === "air") {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), (ico_prod_default()));
    }
});
var ListView = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-18"
})(_templateObject20());
var BoxSoldout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-19"
})(_templateObject21());
var TitProd = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-9744d673-20"
})(_templateObject22());
var BoxInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-21"
})(_templateObject23());
var AirIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9744d673-22"
})(_templateObject24());
var DefinitionList = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-9744d673-23"
})(_templateObject26(), function(props) {
    return props.types === "bar" && (0,styled_components_browser_esm/* css */.iv)(_templateObject25());
});
var BtnArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9744d673-24"
})(_templateObject27());


// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts + 43 modules
var useConfigureAxios = __webpack_require__(21741);
// EXTERNAL MODULE: ./hooks/services/queries/account/useSigninUser.ts
var useSigninUser = __webpack_require__(5142);
// EXTERNAL MODULE: ./hooks/services/queries/essential/user/useGetRecently.ts
var useGetRecently = __webpack_require__(40208);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Flag/index.cjs
var Flag = __webpack_require__(29621);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var common_Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/layout/floating/Desktop/Recently.tsx
/* eslint-disable no-case-declarations */ 


















var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
/** pkg_add_evCd_wish */ // const brazeWish = async (evCd: string, detailedUrl: string) => {
// 	const eventDetailPromise = await eventDetailAsync(evCd);
// 	const eventDetail = eventDetailPromise.data.body || null;
// 	const eventPricePromise = await eventPriceAsync(evCd);
// 	const eventPrice = eventPricePromise.data.body || null;
// 	const price = getPrice(eventPrice);
// 	const eventMileagePromise = await eventMileageAsync(evCd);
// 	const eventMileage = eventMileagePromise.data.body || null;
// 	// brazeUtil.pushEvent("pkg_add_evCd_wish", BrazeClickPkgAddEvCdWish(eventDetail, price, eventMileage, detailedUrl));
// };
var getWishData = function(recently) {
    var type = recently.type, detailedUrl = recently.detailedUrl, goodsId = recently.goodsId, webCustId = recently.webCustId, goodsName = recently.goodsName, imgUrl = recently.imgUrl;
    var queries = (0,commonUtil/* getQueryParams */.vl)(decodeURIComponent(detailedUrl));
    var add = {};
    var remove = {};
    switch(type){
        case "PKG":
        case "DMT":
            add = {
                webCustNo: webCustId,
                goodsCd: goodsId.split("-")[0],
                goodsNm: "",
                evCd: goodsId,
                diviCd: "E",
                imageThum: "",
                link: detailedUrl,
                itemCategoryCode: "".concat(goodsId.substring(0, 1) === "K" ? "D" : "P"),
                cityCode: "",
                latestAmount: ""
            };
            break;
        case "HOTEL":
        case "TOUR":
            var _regionCode;
            add = {
                webCustNo: webCustId,
                goodsCd: goodsId,
                goodsNm: goodsName,
                evCd: "",
                diviCd: "",
                imageThum: imgUrl,
                link: detailedUrl,
                itemCategoryCode: type === "HOTEL" ? "IC02" : "IC04",
                cityCode: (_regionCode = queries.regionCode) !== null && _regionCode !== void 0 ? _regionCode : "",
                latestAmount: ""
            };
            break;
        default:
            break;
    }
    remove = {
        wishList: [
            (0,_object_spread/* default */.Z)({}, add)
        ]
    };
    return {
        add: add,
        remove: remove
    };
};
var InfoByType = function(param) {
    var type = param.type, information = param.information;
    var infoArr = information.split(";");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (type === "PKG" || type === "DMT") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AirIcon, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://static.ybtour.com/images/air/".concat(infoArr[6], ".png"),
                                alt: infoArr[7]
                            }),
                            infoArr[7]
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1])
                    })
                ]
            }),
            type === "RENT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1], " ").concat(infoArr[2]),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "~".concat(dayjs_min_default()(infoArr[3]).format("YY.MM.DD")).concat(infoArr[4], " ").concat(infoArr[5])
                    ]
                })
            }),
            type === "AIR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {
                children: infoArr.length >= 7 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(infoArr[0]).concat(infoArr[1], "~").concat(infoArr[2]).concat(infoArr[3])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                            types: "bar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    children: infoArr[4]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    children: "".concat(infoArr[5], ", ").concat(infoArr[6])
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(infoArr[0]).concat(infoArr[1])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                            types: "bar",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                    children: infoArr[3]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    children: "".concat(infoArr[4], ", ").concat(infoArr[5])
                                })
                            ]
                        })
                    ]
                })
            }),
            type === "HOTEL" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(dayjs_min_default()(infoArr[0]).format("YY.MM.DD")).concat(infoArr[1], "~").concat(dayjs_min_default()(infoArr[2]).format("YY.MM.DD")).concat(infoArr[3])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefinitionList, {
                        types: "bar",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: infoArr[4]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: "".concat(infoArr[5], ", ").concat(infoArr[6])
                            })
                        ]
                    })
                ]
            }),
            type === "TOUR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo, {})
        ]
    });
};
var FlagByType = function(param) {
    var type = param.type, category = param.category;
    var flagArr = category.split(";");
    return type === "PKG" || type === "DMT" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
        $type: "product",
        $flag: flagArr[0],
        text: flagArr[1]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
        $type: "product",
        $flag: type.toLowerCase(),
        text: category
    });
};
/** 찜하기 */ var WishByType = function(recently) {
    var type = recently.type, evCd = recently.goodsId, wishListYn = recently.wishListYn, signinCode = recently.signinCode;
    // 렌트카 | 항공 비노출
    if (type === "RENT" || type === "AIR") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var isWish = wishListYn === "Y";
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var addWish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "POST", _tmp.data = getWishData(recently).add, _tmp)).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if (result.data.code === "0000") {
                            alert("찜한 상품으로 등록되었습니다.");
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useGetRecently"
                            ], _tmp1.type = "active", _tmp1));
                        } else {
                            throw new Error();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function addWish() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeWish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isWish) return [
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "DELETE", _tmp.data = getWishData(recently).remove, _tmp)).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        _tmp1 = {};
                        if (result.data.code === "0000") {
                            alert("찜한 상품이 삭제되었습니다.");
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useGetRecently"
                            ], _tmp1.type = "active", _tmp1));
                        } else {
                            throw new Error();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function removeWish() {
            return _ref.apply(this, arguments);
        };
    }();
    var wish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!isWish) {
                    /** 위시리스트 등록 */ addWish();
                /** braze */ // if (type === "PKG" || type === "DMT") brazeWish(evCd, detailedUrl);
                } else {
                    /** 위시리스트 삭제 */ removeWish();
                }
                return [
                    2
                ];
            });
        });
        return function wish(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    if (!evCd) throw new Error("필수 파라미터 누락");
                    if (signinCode !== "0000") {
                        if (confirm("로그인이 필요한 서비스입니다.")) LoginUtil.login();
                    } else {
                        wish(e);
                    }
                } catch (e1) {
                    ;
                    alert("오류가 발생하였습니다. <br/>".concat(e1));
                }
                return [
                    2
                ];
            });
        });
        return function onClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
        icon: "wishList",
        onClick: onClick,
        isActive: isWish,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "상품 찜하기"
        })
    });
};
var RecentlyComponent = function(props) {
    var ref, ref1, ref2, ref3;
    var open = props.open, show = props.show, closeOpen = props.closeOpen, closeShow = props.closeShow;
    (0,react.useEffect)(function() {
        document.body.style.overflow = show ? "hidden" : "";
    }, [
        show
    ]);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /** 로그인 정보 */ var signin = (0,useSigninUser/* default */.ZP)({
        throwOnError: false
    });
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    var signinCode = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.code) || "9999";
    /** 최근 본 상품 ID */ var userId = (0,commonUtil/* getCookie */.ej)("userId") || (window.ensureUserHasUniqueId ? window.ensureUserHasUniqueId() : "");
    /** 최근 본 리스트 */ var recentlyListFetch = (0,useGetRecently/* default */.Z)(userId, webCustNo, {
        enabled: !signin.isFetching && !!userId,
        throwOnError: false
    });
    var recentlyList = ((ref2 = recentlyListFetch.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3.productResultList) || [];
    // viewDate 기준 내림차순 정렬
    var recentlyData = (0,react.useMemo)(function() {
        var sortedList = (0,_to_consumable_array/* default */.Z)(recentlyList).sort(function(a, b) {
            if (a.viewDate < b.viewDate) return 1;
            if (a.viewDate > b.viewDate) return -1;
            return 0;
        });
        return sortedList.reduce(function(acc, cur) {
            var date = dayjs_min_default()(cur.viewDate).format("YYYY.MM.DD");
            acc[date] = acc[date] || [];
            acc[date].push(cur);
            return acc;
        }, {});
    }, [
        recentlyList
    ]);
    /** 최근 본 삭제 */ var deleteRecently = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(recently) {
            var data, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        data = recently ? (_tmp.productList = [
                            (0,_object_spread/* default */.Z)({}, recently)
                        ], _tmp) : (_tmp1.productList = [
                            {
                                userId: userId,
                                webCustId: webCustNo,
                                goodsId: ""
                            }
                        ], _tmp1);
                        _tmp2 = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp2.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/user/recentlyViewed"), _tmp2.method = "DELETE", _tmp2.data = data, _tmp2)).then(function(res) {
                                if (res.data.code === "0000") {
                                    /* 데이터 최신화 */ queryClient.refetchQueries({
                                        queryKey: [
                                            "useGetRecently"
                                        ],
                                        type: "active"
                                    });
                                } else {
                                    throw new Error();
                                }
                            }).catch(function(e) {
                                throw new Error();
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteRecently(recently) {
            return _ref.apply(this, arguments);
        };
    }();
    /** 찜목록 버튼 */ var mypageWishButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var nextUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                nextUrl = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/wishGoods.yb");
                if (signinCode === "0000") {
                    window.location.href = nextUrl;
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (confirm("로그인이 필요한 서비스입니다.")) LoginUtil.login();
                }
                return [
                    2
                ];
            });
        });
        return function mypageWishButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupContainer, {
        open: open,
        show: show,
        "data-show": String(show),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupDimm, {
                onClick: closeShow,
                onAnimationEnd: function() {
                    return !show && closeOpen();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupTop, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                                children: [
                                    "최근 본 상품",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: recentlyList.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                                        onClick: mypageWishButton,
                                        types: "base",
                                        width: "basic",
                                        size: "default",
                                        text: "찜목록"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* PopupCloseButton */.sz, {
                                        onClose: closeShow
                                    })
                                ]
                            })
                        ]
                    }),
                    recentlyList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TxtEmpty, {
                        children: "최근 본 상품이 없습니다"
                    }),
                    recentlyList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupArea, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopArea, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "최대 30개까지 조회가 가능합니다."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            if (confirm("최근 본 상품 리스트를 모두 삭제합니다.")) deleteRecently();
                                        },
                                        children: "전체 삭제"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryList, {
                                children: Object.keys(recentlyData).map(function(date) {
                                    var recentlyArr = recentlyData[date];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitDate, {
                                                children: "".concat(dayjs_min_default()(date).format("MM.DD"), "(").concat(daykor[dayjs_min_default()(date).day()], ")")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdList, {
                                                children: recentlyArr.map(function(item, index) {
                                                    var information = item.information, goodsName = item.goodsName, category = item.category, type = item.type, detailedUrl = item.detailedUrl, soldoutYn = item.soldoutYn, wishListYn = item.wishListYn;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdListItem, {
                                                        soldout: soldoutYn === "Y",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxSoldout, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "판매 종료"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: function() {
                                                                                    return window.location.href = item.changedUrl;
                                                                                },
                                                                                children: "일정 변경"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                onClick: function() {
                                                                                    return deleteRecently(item);
                                                                                },
                                                                                children: "삭제"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Prod, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbImg, {
                                                                        types: type.toLowerCase(),
                                                                        children: item.imgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Noimage/* Noimage */.T, {
                                                                            width: "120px",
                                                                            height: "80px",
                                                                            src: item.imgUrl,
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListView, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerTag, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagByType, {
                                                                                        type: type,
                                                                                        category: category
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WishByType, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                                                                wishListYn: wishListYn,
                                                                                                signinCode: signinCode
                                                                                            })),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdDeleteBtn, {
                                                                                                onClick: function() {
                                                                                                    return deleteRecently(item);
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: "최근 본 상품 삭제"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitProd, {
                                                                                children: goodsName
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoByType, {
                                                                                type: type,
                                                                                information: information
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdData, {
                                                                onClick: function() {
                                                                    return location.href = detailedUrl;
                                                                }
                                                            })
                                                        ]
                                                    }, "".concat(item.goodsId).concat(index));
                                                })
                                            })
                                        ]
                                    }, date);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Recently = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Desktop_Recently = (Recently);

// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
;// CONCATENATED MODULE: ./framework/ui/desktop/header/index.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	a {\n		position: absolute;\n		display: block;\n		width: 1px;\n		height: 1px;\n		margin-bottom: -1px;\n		left: 0;\n		top: 0;\n		z-index: 100;\n		font-size: 14px;\n		font-weight: bold;\n		color: #fff;\n		text-align: center;\n		overflow: hidden;\n	}\n\n	&:focus {\n		width: 100%;\n		height: auto;\n		padding: 5px 0;\n		background: #333;\n	}\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: -0.02em;\n\n	button {\n		cursor: pointer;\n		overflow: visible;\n		border: 0 none;\n		background-color: transparent;\n		font-family: "pr-font-medium", Sans-serif;\n		font-weight: normal;\n		font-size: 15px;\n		color: #555;\n		text-indent: 0;\n	}\n	h1 a {\n		display: block;\n	}\n	h1 a img {\n		width: 165px;\n		height: 44px;\n		vertical-align: top;\n	}\n'
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	height: 70px;\n	background-color: #fff;\n	z-index: 11;\n\n	a {\n		display: block;\n		height: 100%;\n	}\n\n	div {\n		position: relative;\n		width: 1200px;\n		height: 70px;\n		margin: 0 auto;\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		vertical-align: top;\n	}\n"
    ]);
    header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 0;\n	top: 50%;\n	width: 25px;\n	height: 25px;\n	padding: 0;\n	margin: 0;\n	border: 0;\n	background: none;\n	transform: translateY(-50%);\n\n	&:before,\n	&:after {\n		position: absolute;\n		right: -3px;\n		height: 1px;\n		width: 32px;\n		background: #000;\n		border-radius: 1px;\n		content: "";\n	}\n\n	&:before {\n		transform: rotate(45deg);\n	}\n\n	&:after {\n		transform: rotate(-45deg);\n	}\n'
    ]);
    header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-top: 30px;\n	background-color: #fff;\n	z-index: 15;\n"
    ]);
    header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: #fff;\n	box-sizing: border-box;\n	border-bottom: 1px solid #222;\n"
    ]);
    header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 1200px;\n	padding: 20px 0 10px;\n	margin: 0 auto;\n\n	> div:first-child {\n		display: flex;\n		gap: 30px;\n		align-items: center;\n	}\n\n	h1 {\n		line-height: 1;\n	}\n"
    ]);
    header_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	gap: 40px;\n	align-items: center;\n\n	ul {\n		display: flex;\n	}\n	li {\n		position: relative;\n		padding-right: 13px;\n		margin-right: 10px;\n		line-height: 1.6;\n\n		&:after {\n			position: absolute;\n			right: 0;\n			top: 50%;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: #ccc;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n		}\n\n		&:last-child::after {\n			display: none;\n		}\n	}\n	a {\n		color: #111;\n		font-size: 17px;\n		box-sizing: border-box;\n	}\n'
    ]);
    header_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 10px;\n\n	a {\n		box-sizing: border-box;\n	}\n"
    ]);
    header_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 36px;\n	height: 36px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_mypage.png) center / cover no-repeat;\n"
    ]);
    header_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function header_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    header_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function header_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: block;\n	padding: 20px 15px;\n	font-family: "pr-font-regular";\n	font-size: 17px;\n	color: #555;\n	line-height: 1;\n'
    ]);
    header_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function header_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: -2px;\n	left: 50%;\n	height: 16px;\n	width: 40px;\n	border-radius: 13px;\n	background-color: #ff5c46;\n	color: #fff;\n	font-size: 11px;\n	text-align: center;\n	font-family: "pr-font-bold";\n	line-height: 1.6;\n	transform: translateX(-50%);\n\n	&:after {\n		position: absolute;\n		bottom: -3px;\n		left: 50%;\n		transform: translateX(-50%);\n		width: 0px;\n		height: 0px;\n		border-top: 4px solid #ff5c46;\n		border-left: 4px solid transparent;\n		border-right: 4px solid transparent;\n		content: "";\n	}\n'
    ]);
    header_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function header_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 57px;\n	left: 0;\n	width: 100%;\n	background-color: #fff;\n	border-top: 1px solid #222;\n	visibility: hidden;\n\n	&:has(li)::before {\n		position: absolute;\n		top: 49px;\n		left: 0;\n		width: 100%;\n		height: 1px;\n		background-color: #ddd;\n		content: "";\n	}\n'
    ]);
    header_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function header_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n\n	> ul {\n		display: flex;\n	}\n"
    ]);
    header_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function header_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n\n	> ul {\n		display: flex;\n		width: 1200px;\n		margin: 0 auto;\n\n		> li:first-child {\n			margin-left: -15px;\n		}\n	}\n\n	li:hover {\n		",
        " {\n			visibility: visible;\n		}\n\n		",
        " {\n			color: #222;\n			font-weight: bold;\n		}\n	}\n"
    ]);
    header_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function header_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	bottom: 0;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	z-index: 10;\n"
    ]);
    header_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function header_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	left: 0;\n	top: 50px;\n	display: none;\n	width: 100%;\n	min-height: 450px;\n	height: 450px;\n	background-color: #fff;\n	z-index: 10;\n"
    ]);
    header_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function header_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding-right: 20px;\n\n	&:last-child {\n		padding-right: 0;\n	}\n\n	> a {\n		position: relative;\n		display: flex;\n		align-items: center;\n		height: 50px;\n		font-size: 15px;\n		color: #555;\n		cursor: pointer;\n	}\n\n	&:hover {\n		> a {\n			font-weight: bold;\n			color: #222;\n\n			&:after {\n				position: absolute;\n				bottom: 1px;\n				left: 50%;\n				transform: translateX(-50%);\n				display: block;\n				width: 100%;\n				height: 2px;\n				background-color: #222;\n				height: 2px;\n				content: "";\n			}\n		}\n\n		',
        ", ",
        " {\n			display: block;\n		}\n	}\n"
    ]);
    header_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function header_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	float: right;\n	display: flex;\n	gap: 15px;\n	margin-top: -33px;\n	font-size: 14px;\n	color: #777;\n\n	li:hover {\n		color: #4567ad;\n	}\n"
    ]);
    header_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function header_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    header_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function header_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: block;\n	font-family: "pr-font-medium";\n	font-size: 18px;\n	color: #4567ad;\n\n	a {\n		margin-left: 7px;\n		color: #111;\n	}\n'
    ]);
    header_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function header_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding: 30px;\n	flex-basis: 300px;\n	box-sizing: border-box;\n\n	&:first-child {\n		flex-grow: 1;\n		background-color: #f5f5f5;\n	}\n\n	&:first-child:after {\n		display: none;\n	}\n\n	&:after {\n		position: absolute;\n		right: 0;\n		top: 0;\n		width: 1px;\n		height: 100%;\n		background-color: #ddd;\n		content: "";\n	}\n\n	ul {\n		display: flex;\n		flex-direction: column;\n		gap: 20px;\n		flex-wrap: wrap;\n		height: 340px;\n		width: 100%;\n		margin-top: 20px;\n	}\n\n	li {\n		width: 240px;\n		line-height: 1;\n	}\n'
    ]);
    header_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function header_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	li a {\n		display: block;\n		width: 100%;\n		align-items: center;\n		font-size: 15px;\n		color: #555;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		-o-text-overflow: ellipsis;\n		overflow: hidden;\n\n		&:hover {\n			color: #111;\n			text-decoration: underline;\n		}\n	}\n"
    ]);
    header_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function header_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 340px;\n	height: 46px;\n	padding: 0 25px 0 20px;\n	border-radius: 30px;\n	border: 2px solid #ffcb31;\n	box-sizing: border-box;\n\n	a {\n		display: block;\n		width: 100%;\n		padding: 12px 0;\n		color: #999;\n		font-size: 15px;\n		",
        "\n	}\n"
    ]);
    header_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function header_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 23px;\n	height: 22px;\n	flex-shrink: 0;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/btn_search.png) no-repeat;\n	z-index: 1;\n"
    ]);
    header_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function header_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	width: 100%;\n	height: 30px;\n	background-color: #f3f3f3;\n	box-sizing: border-box;\n	font-size: 13px;\n	color: #555;\n\n	ul {\n		display: flex;\n		gap: 20px;\n		align-items: center;\n		justify-content: end;\n	}\n\n	li:hover {\n		color: #222;\n	}\n\n	a {\n		line-height: 30px;\n	}\n"
    ]);
    header_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function header_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    header_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-right: 12px;\n	color: #111;\n	cursor: pointer;\n	line-height: 1.6;\n\n	&:after {\n		content: "";\n		position: absolute;\n		top: 50%;\n		right: 0;\n		border-top: 4px solid #222;\n		border-left: 3px solid transparent;\n		border-right: 3px solid transparent;\n		transform: translateY(-50%);\n	}\n\n	',
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 25px;\n	right: -20px;\n	z-index: 1;\n	display: flex;\n	flex-direction: column;\n	gap: 12px;\n	width: 110px;\n	padding: 15px 15px 20px;\n	border: 1px solid #222;\n	border-radius: 3px;\n	background-color: #fff;\n	font-size: 13px;\n	color: #555;\n	box-sizing: border-box;\n\n	&:before {\n		content: "";\n		position: absolute;\n		top: -8px;\n		right: 50%;\n		width: 7px;\n		height: 7px;\n		background: #fff;\n		border-right: 1px solid #222;\n		border-bottom: 1px solid #222;\n		transform: rotate(-135deg) translateX(-50%);\n	}\n\n	a {\n		display: block;\n		line-height: 1;\n\n		&:hover {\n			color: #4567ad;\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}




var SkipNavi = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-0"
})(header_templateObject());
var HeaderWrap = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-3e8fffb4-1"
})(header_templateObject1());
var TopBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-2"
})(header_templateObject2());
var BtnBannerClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3e8fffb4-3"
})(header_templateObject3());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-4"
})(header_templateObject4());
var Gnb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-5"
})(header_templateObject5());
var TopNavWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-6"
})(header_templateObject6());
var UtileLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-7"
})(header_templateObject7());
var BtnGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-8"
})(header_templateObject8());
var BtnMypage = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-3e8fffb4-9"
})(header_templateObject9());
var BtnRecent = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-3e8fffb4-10"
})(header_templateObject10(), function(props) {
    return props.$hasRecent ? "width: 34px;\n				height: 34px;\n				border: 1px solid #bbb;\n				border-radius: 8px;\n				overflow: hidden;\n\n				img {\n					width: 100%;\n					height: 100%;\n				}\n				" : "\n				width: 36px;\n				height: 36px;\n				border: none;\n				background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_recent.png) center / cover no-repeat;\n			";
});
var GnbItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-3e8fffb4-11"
})(header_templateObject11());
var IconBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3e8fffb4-12"
})(header_templateObject12());
var Lnb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-13"
})(header_templateObject13());
var LnbWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-14"
})(header_templateObject14());
var Navi = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-3e8fffb4-15"
})(header_templateObject15(), Lnb, GnbItem);
var Dim = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-16"
})(header_templateObject16());
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-17"
})(header_templateObject17());
var LnbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3e8fffb4-18"
})(header_templateObject18(), Dim, Category);
var EventNavi = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3e8fffb4-19"
})(header_templateObject19());
var CategoryWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-20"
})(header_templateObject20());
var CategorySubtitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3e8fffb4-21"
})(header_templateObject21());
var CategoryArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-22"
})(header_templateObject22());
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3e8fffb4-23"
})(header_templateObject23());
var SearchWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-24"
})(header_templateObject24(), (0,desktop_text/* Ellipsis */.mH)(1));
var BtnSearch = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3e8fffb4-25"
})(header_templateObject25());
var GnbUtil = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-26"
})(header_templateObject26());
var GnbUtilWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-27"
})(header_templateObject27());
var Login = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3e8fffb4-28"
})(_templateObject28(), function(props) {
    return props.$isShow && "\n		&:after {\n			border-top: 0;\n			border-bottom: 4px solid #222;\n		}\n	";
});
var LoginTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8fffb4-29"
})(_templateObject29());
var Header = function() {
    var ref = useState(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var tooltipRef = useRef(null);
    var ref1 = useState(false), isDim = ref1[0], setIsisDim = ref1[1];
    var loginRef = useRef(null);
    var centerRef = useRef(null);
    var depth2WrapRef = useRef(null);
    var naviWrapRef = useRef(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    useEffect(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    // 2 Depth에 3 Depth가 있을 경우 dim 보여주기
    var handleMouseEnter = function() {
        return setIsisDim(true);
    };
    var handleMouseLeave = function() {
        return setIsisDim(false);
    };
    // 2 Depth가 center로 설정 될 경우
    useEffect(function() {
        var updatePosition = function() {
            if (!centerRef.current || !depth2WrapRef.current || !naviWrapRef.current) return;
            var centerElement = centerRef.current;
            var depth2Wrap = depth2WrapRef.current;
            var naviWrap = naviWrapRef.current;
            var position = centerElement.getBoundingClientRect();
            var naviPosition = naviWrap.getBoundingClientRect();
            var totalWidth = 0;
            // 자식 요소들의 전체 width 값을 구하기
            Array.from(depth2Wrap.children).forEach(function(child) {
                var childElement = child;
                totalWidth += childElement.offsetWidth;
            });
            depth2Wrap.style.paddingLeft = "".concat(position.left - naviPosition.left - totalWidth / 2 + position.width / 2, "px");
        };
        // 초기 위치 설정
        updatePosition();
        // 브라우저가 리사이즈될 때마다 위치 업데이트
        window.addEventListener("resize", updatePosition);
        return function() {
            window.removeEventListener("resize", updatePosition);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(HeaderWrap, {
        children: [
            /*#__PURE__*/ _jsx(TopBanner, {
                style: {
                    backgroundColor: "#fdebe9"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner.jpg",
                                alt: "배너 이미지"
                            })
                        }),
                        /*#__PURE__*/ _jsx(BtnBannerClose, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "배너 닫기"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsxs(SkipNavi, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "#content",
                                children: "본문 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb",
                                children: "카테고리 메뉴 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb-login",
                                children: "로그인 메뉴 바로가기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Gnb, {
                        children: [
                            /*#__PURE__*/ _jsxs(TopNavWrap, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("h1", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "/index.yb",
                                                    children: /*#__PURE__*/ _jsx("img", {
                                                        src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png",
                                                        alt: "노랑풍선"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs(SearchWrap, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "#",
                                                        children: "검색 프로모션 영역 텍스트"
                                                    }),
                                                    /*#__PURE__*/ _jsx(BtnSearch, {
                                                        type: "button",
                                                        onClick: function() {
                                                            location.href = "https://pkg.ybtour.co.kr/common/searchGoods.yb";
                                                        },
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: "검색"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(UtileLinks, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("ul", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "베스트"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "마감임박"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "출발보장"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "썸머특가"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "#",
                                                            children: "당장노랑"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(BtnGroup, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(BtnMypage, {
                                                        href: "https://pkg.ybtour.co.kr/mypage/index.yb",
                                                        children: /*#__PURE__*/ _jsx(Accessibility, {
                                                            children: "마이페이지"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(BtnRecent, {
                                                        href: "#",
                                                        $hasRecent: true,
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Accessibility, {
                                                                children: "최근본"
                                                            }),
                                                            /*#__PURE__*/ _jsx("img", {
                                                                src: "https://dimgcdn.ybtour.co.kr/TN/99/99897c62991b42e78a3c3fad024dce69.tn.410x280.jpg",
                                                                alt: "상품 이미지"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Navi, {
                                children: /*#__PURE__*/ _jsxs("ul", {
                                    ref: naviWrapRef,
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(GnbItem, {
                                                    href: "#",
                                                    children: "해외패키지"
                                                }),
                                                /*#__PURE__*/ _jsx(Lnb, {
                                                    children: /*#__PURE__*/ _jsxs(LnbWrap, {
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "유럽"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 유럽"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_6"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_7"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_8"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_9"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "6"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가 프로모션 프로모션 프로모션 프로모션"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "아시아나 항공 유럽 SUMMER 특가"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "유럽의 숨겨진 보물, HENANN RESORT"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "상상 이상의 행복한 허니문을 위한 Fourseasons in France"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "동남아"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 동남아"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_6"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_7"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_8"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_9"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_10"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_11"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_12"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_13"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_14"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_15"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_16"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_17"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_18"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "3"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "4"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "5"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "6"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "창립 21주년 기념, 동남아 5만원 할인!"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "격리없이 떠나는 푸켓"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "샹그릴라&요트선셋투어 in 싱가포르"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "동남아! 할인챌린지 앙코르전"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "아시아나 A380 타고 떠나는 방콕/파타야"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "일본"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 일본"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(CategoryArea, {}),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "프로모션"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "오사카 여행 200% 즐기는 방법"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "나만 알고싶은 소도시로, 단풍여행"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "겨울시즌 온천여행 오이타"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "황금연휴 출발확정"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "MZ 취향저격 특급호텔 호캉스 MZ 취향저격 특급호텔 호캉스"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(LnbItem, {
                                                                        onMouseEnter: handleMouseEnter,
                                                                        onMouseLeave: handleMouseLeave,
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "#",
                                                                                children: "괌/사이판"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Category, {
                                                                                children: /*#__PURE__*/ _jsxs(CategoryWrap, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsxs(CategorySubtitle, {
                                                                                                    children: [
                                                                                                        "지역별",
                                                                                                        /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[해외패키지] 괌/사이판"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsxs(List, {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_1"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_2"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx("li", {
                                                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                                                href: "#",
                                                                                                                children: "[나라] 도시_3"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs(CategoryArea, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(CategorySubtitle, {
                                                                                                    children: "테마별"
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(List, {
                                                                                                    children: /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "여행에 테마를 더하다"
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(CategoryArea, {})
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "호주/뉴질랜드"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "미주/캐나다/하와이"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "중남미/아프리카"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "대만/홍콩/마카오"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "중국/몽골/중아아시아"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(LnbItem, {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "부산/지방 출발"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs(EventNavi, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "기획전"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "이벤트"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("li", {
                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "홈쇼핑"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "에어텔"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs(GnbItem, {
                                                href: "#",
                                                children: [
                                                    /*#__PURE__*/ _jsx(IconBadge, {
                                                        children: "NEW"
                                                    }),
                                                    "허니문"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsxs(GnbItem, {
                                                href: "#",
                                                children: [
                                                    /*#__PURE__*/ _jsx(IconBadge, {
                                                        children: "HOT"
                                                    }),
                                                    "골프"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            ref: centerRef,
                                            children: [
                                                /*#__PURE__*/ _jsx(GnbItem, {
                                                    href: "#",
                                                    children: "테마/크루즈"
                                                }),
                                                /*#__PURE__*/ _jsx(Lnb, {
                                                    children: /*#__PURE__*/ _jsx(LnbWrap, {
                                                        children: /*#__PURE__*/ _jsxs("ul", {
                                                            ref: depth2WrapRef,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "테마여행"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "크루즈"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "프리미엄"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "국내여행"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "항공"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "호텔"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "투어&티켓"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "렌터카"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(GnbItem, {
                                                href: "#",
                                                children: "기업/단체"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(GnbUtil, {
                                id: "gnb-login",
                                children: /*#__PURE__*/ _jsx(GnbUtilWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Login, {
                                                onClick: handleClick,
                                                $isShow: showTooltip,
                                                ref: loginRef,
                                                children: [
                                                    "김노랑 님",
                                                    showTooltip && /*#__PURE__*/ _jsxs(LoginTooltip, {
                                                        ref: tooltipRef,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "개인정보 수정"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "비밀번호 변경"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "SNS 연결 설정"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "#",
                                                    children: "로그아웃"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/mypage/resvInfo.yb",
                                                    children: "예약확인/결제"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                    children: "고객센터"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isDim && /*#__PURE__*/ _jsx(Dim, {})
        ]
    });
};

/* harmony default export */ var header = ((/* unused pure expression or super */ null && (Header)));

// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
;// CONCATENATED MODULE: ./components/layout/header/Desktop/Gnb.tsx









var Lv3List = function(props) {
    var lv1 = props.lv1, lv2 = props.lv2, lv3List = props.lv3List, pmoMenuList = props.pmoMenuList, taggingClick = props.taggingClick;
    var localLv3 = lv3List.filter(function(o) {
        return o.locTypeCd !== "T";
    }) || [];
    var themaLv3 = lv3List.filter(function(o) {
        return o.locTypeCd === "T";
    }) || [];
    var promotionLv3 = pmoMenuList.filter(function(o) {
        return o.dspSid === lv2.dspSid;
    }) || [];
    var isLv3 = lv1.areaMainYn === "Y";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLv3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryArea, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySubtitle, {
                                    children: [
                                        "지역",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: lv2.dspUrl || "#",
                                            onClick: function() {
                                                return taggingClick(lv2);
                                            },
                                            children: [
                                                "[",
                                                lv1.dspNm,
                                                "] ",
                                                lv2.dspNm
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                    children: localLv3.map(function(local, localIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: local.dspUrl || "#",
                                                target: (0,commonUtil/* getTarget */.U9)(local.webMenuTarget),
                                                onClick: function() {
                                                    return taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, local), {
                                                        dspOrder: localIndex + 1
                                                    }));
                                                },
                                                children: local.dspNm
                                            })
                                        }, local.dspSid + localIndex);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryArea, {
                            children: themaLv3.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySubtitle, {
                                        children: "테마별"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                        children: themaLv3.slice(0, 9).map(function(thema, themaIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: thema.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(thema.webMenuTarget),
                                                    onClick: function() {
                                                        return taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thema), {
                                                            dspOrder: themaIndex + 1
                                                        }));
                                                    },
                                                    children: thema.dspNm
                                                })
                                            }, thema.dspSid + themaIndex);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryArea, {
                            children: promotionLv3.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySubtitle, {
                                        children: "프로모션"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                        children: promotionLv3.slice(0, 9).map(function(promotion, promotionIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: promotion.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(promotion.webMenuTarget),
                                                    onClick: function() {
                                                        return taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promotion), {
                                                            dspOrder: promotionIndex + 1
                                                        }));
                                                    },
                                                    children: promotion.subDspNm
                                                })
                                            }, promotion.dspSid + promotionIndex);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var Lv2List = function(props) {
    var globalMenu = props.globalMenu, hoverLv1 = props.hoverLv1, handelEnterLv2 = props.handelEnterLv2, handelLeaveLv2 = props.handelLeaveLv2, taggingClick = props.taggingClick;
    var menuLv1List = globalMenu.menuLv1List, menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List, pmoMenuList = globalMenu.pmoMenuList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuLv2List.filter(function(o) {
            return o.dspSidHi === hoverLv1 && o.homeYn === "Y";
        }).map(function(lv2, lv2Index) {
            var lv1 = menuLv1List.find(function(o) {
                return o.dspSid === lv2.dspSidHi;
            }); // 1depth
            var lv3List = menuLv3List.filter(function(o) {
                return o.dspSidHi === lv2.dspSid && o.homeYn === "Y";
            }) || [];
            var isLv3 = lv1.areaMainYn === "Y";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LnbItem, {
                onMouseEnter: function() {
                    return isLv3 && handelEnterLv2();
                },
                onMouseLeave: function() {
                    return isLv3 && handelLeaveLv2();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: lv2.dspUrl || "#",
                        target: (0,commonUtil/* getTarget */.U9)(lv2.webMenuTarget),
                        onClick: function() {
                            return taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, lv2), {
                                dspOrder: lv2Index + 1
                            }));
                        },
                        children: lv2.dspNm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lv3List, {
                        lv1: lv1,
                        lv2: lv2,
                        lv3List: lv3List,
                        pmoMenuList: pmoMenuList,
                        taggingClick: taggingClick
                    })
                ]
            }, lv2.dspSid + lv2Index);
        })
    });
};
var GNBComponent = function(props) {
    var ref;
    var handleDim = props.handleDim;
    /** 메뉴 관련 API */ var globalMenuFetch = (0,useGlobalMenu/* default */.Z)();
    var globalMenu = (ref = globalMenuFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var menuLv1List = globalMenu === null || globalMenu === void 0 ? void 0 : globalMenu.menuLv1List;
    var subMenuList = globalMenu === null || globalMenu === void 0 ? void 0 : globalMenu.subMenuList;
    var centerRef = (0,react.useRef)([]);
    var depth2WrapRef = (0,react.useRef)([]);
    var naviWrapRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), hoverLv1 = ref1[0], setHoverLv1 = ref1[1]; // dspSid
    var ref2 = (0,react.useState)(0), hoverIndex = ref2[0], setHoverIndex = ref2[1];
    var handleEnterLv1 = function(index, dspSid) {
        setHoverLv1(dspSid);
        setHoverIndex(index);
    };
    // LV2 에 LV3 가 있을 경우 dim 보여주기
    var handelEnterLv2 = function() {
        return handleDim(true);
    };
    var handelLeaveLv2 = function() {
        return handleDim(false);
    };
    (0,react.useEffect)(function() {
        if (!menuLv1List) return;
        var isAlign = menuLv1List.some(function(v) {
            return v.dspSid === hoverLv1 && v.align === "N";
        });
        // 2 Depth가 center로 설정 될 경우 (align === "N")
        if (!isAlign || !hoverIndex || !centerRef.current || !depth2WrapRef.current || !naviWrapRef.current) return;
        var centerElement = centerRef.current[hoverIndex];
        var depth2Wrap = depth2WrapRef.current[hoverIndex];
        var naviWrap = naviWrapRef.current;
        var position = centerElement.getBoundingClientRect();
        var naviPosition = naviWrap.getBoundingClientRect();
        // // 자식 요소들의 전체 width 값을 구하기
        var totalWidth = Array.from(depth2Wrap.children).reduce(function(total, child) {
            var childElement = child;
            return total + childElement.offsetWidth;
        }, 0);
        depth2Wrap.style.paddingLeft = "".concat(position.left - naviPosition.left - totalWidth / 2 + position.width / 2, "px");
    }, [
        hoverLv1
    ]);
    // LV1 클릭 이벤트 (넷스루)
    var handleClickLv1 = function(dspNm) {
        nLogger.event("ds_click", {
            _n_click_area: "n_gnb_main_quick_menu",
            _n_banner: dspNm
        });
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("gnb_click").taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navi, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            ref: naviWrapRef,
            children: menuLv1List && menuLv1List.filter(function(o) {
                return o.homeYn === "Y";
            }).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    ref: function(el) {
                        return centerRef.current[index] = el;
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GnbItem, {
                            href: item.dspUrl || "#",
                            target: (0,commonUtil/* getTarget */.U9)(item.webMenuTarget),
                            onClick: function() {
                                handleClickLv1(item.dspNm);
                                taggingClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    dspOrder: index + 1
                                }));
                            },
                            onMouseEnter: function() {
                                return handleEnterLv1(index, item.dspSid);
                            },
                            children: [
                                item.iconYn === "Y" && item.iconType && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBadge, {
                                    children: item.iconType
                                }),
                                item.dspNm
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lnb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LnbWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        ref: function(el) {
                                            return depth2WrapRef.current[index] = el;
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lv2List, {
                                            globalMenu: globalMenu,
                                            hoverLv1: hoverLv1,
                                            handelEnterLv2: handelEnterLv2,
                                            handelLeaveLv2: handelLeaveLv2,
                                            taggingClick: taggingClick
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventNavi, {
                                        children: subMenuList && subMenuList.filter(function(o) {
                                            return o.dspSid === hoverLv1 && o.subDspTypeCd === "SUB";
                                        }).map(function(sub, subIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: sub.dspUrl || "#",
                                                    target: (0,commonUtil/* getTarget */.U9)(sub.webMenuTarget),
                                                    children: sub.subDspNm
                                                })
                                            }, subIndex);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
var GNB = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "GNB Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GNBComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var Desktop_Gnb = (GNB);

;// CONCATENATED MODULE: ./framework/ui/desktop/header/NewHeader.tsx

function NewHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	a {\n		position: absolute;\n		display: block;\n		width: 1px;\n		height: 1px;\n		margin-bottom: -1px;\n		left: 0;\n		top: 0;\n		z-index: 100;\n		font-size: 14px;\n		font-weight: bold;\n		color: #fff;\n		text-align: center;\n		overflow: hidden;\n	}\n\n	&:focus {\n		width: 100%;\n		height: auto;\n		padding: 5px 0;\n		background: #333;\n	}\n"
    ]);
    NewHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: -0.02em;\n\n	button {\n		cursor: pointer;\n		overflow: visible;\n		border: 0 none;\n		background-color: transparent;\n		font-family: "pr-font-medium", Sans-serif;\n		font-weight: normal;\n		font-size: 15px;\n		color: #555;\n		text-indent: 0;\n	}\n	h1 a {\n		display: block;\n	}\n	h1 a img {\n		width: 165px;\n		height: 44px;\n		vertical-align: top;\n	}\n	nav {\n		position: static;\n	}\n'
    ]);
    NewHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	height: 70px;\n	z-index: 11;\n\n	a {\n		display: block;\n		height: 100%;\n	}\n\n	div {\n		position: relative;\n		width: 1200px;\n		height: 70px;\n		margin: 0 auto;\n	}\n\n	img {\n		width: 100%;\n		height: 100%;\n		vertical-align: top;\n	}\n"
    ]);
    NewHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 0;\n	top: 50%;\n	width: 25px;\n	height: 25px;\n	padding: 0;\n	margin: 0;\n	border: 0;\n	background: none;\n	transform: translateY(-50%);\n\n	&:before,\n	&:after {\n		position: absolute;\n		right: -3px;\n		height: 1px;\n		width: 32px;\n		background: #000;\n		border-radius: 1px;\n		content: "";\n	}\n\n	&:before {\n		transform: rotate(45deg);\n	}\n\n	&:after {\n		transform: rotate(-45deg);\n	}\n'
    ]);
    NewHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewHeader_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding-top: 30px;\n	background-color: #fff;\n	z-index: 10;\n"
    ]);
    NewHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewHeader_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	background-color: #fff;\n	box-sizing: border-box;\n\n	&::after {\n		position: absolute;\n		bottom: 0;\n		height: 1px;\n		width: 100%;\n		background-color: #222;\n		content: "";\n	}\n'
    ]);
    NewHeader_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewHeader_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NewHeader_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	padding: 20px 0 10px;\n\n	> div:first-child {\n		display: flex;\n		gap: 30px;\n		align-items: center;\n	}\n\n	h1 {\n		line-height: 1;\n	}\n"
    ]);
    NewHeader_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NewHeader_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	gap: 40px;\n	align-items: center;\n\n	ul {\n		display: flex;\n	}\n	li {\n		position: relative;\n		padding-right: 13px;\n		margin-right: 10px;\n\n		&:after {\n			position: absolute;\n			right: 0;\n			top: 50%;\n			display: inline-block;\n			width: 3px;\n			height: 3px;\n			background-color: #ccc;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&:last-child {\n			padding-right: 0;\n			margin-right: 0;\n		}\n\n		&:last-child::after {\n			display: none;\n		}\n	}\n	a {\n		color: #111;\n		font-size: 17px;\n	}\n'
    ]);
    NewHeader_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NewHeader_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 10px;\n\n	a {\n		box-sizing: border-box;\n	}\n"
    ]);
    NewHeader_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NewHeader_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 36px;\n	height: 36px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_mypage.png) center / cover no-repeat;\n"
    ]);
    NewHeader_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NewHeader_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-left: -15px;\n\n	> ul {\n		position: relative;\n		z-index: 1;\n		display: flex;\n	}\n"
    ]);
    NewHeader_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NewHeader_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    NewHeader_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NewHeader_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: block;\n	padding: 20px 15px;\n	font-family: "pr-font-regular";\n	font-size: 17px;\n	color: #555;\n	line-height: 1;\n\n	',
        "\n\n	&:hover {\n		color: #222;\n		font-weight: bold;\n	}\n"
    ]);
    NewHeader_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NewHeader_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: -2px;\n	left: 50%;\n	height: 16px;\n	width: 40px;\n	border-radius: 13px;\n	background-color: #ff5c46;\n	color: #fff;\n	font-size: 11px;\n	text-align: center;\n	font-family: "pr-font-bold";\n	line-height: 1.6;\n	transform: translateX(-50%);\n\n	&:after {\n		position: absolute;\n		bottom: -3px;\n		left: 50%;\n		transform: translateX(-50%);\n		width: 0px;\n		height: 0px;\n		border-top: 4px solid #ff5c46;\n		border-left: 4px solid transparent;\n		border-right: 4px solid transparent;\n		content: "";\n	}\n'
    ]);
    NewHeader_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NewHeader_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 163px;\n	left: 0;\n	width: 100%;\n	height: 50px;\n	background-color: #fff;\n	border-bottom: 1px solid #ddd;\n	box-sizing: border-box;\n"
    ]);
    NewHeader_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NewHeader_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	align-items: center;\n	width: 1200px;\n	margin: 0 auto;\n\n	> ul {\n		display: flex;\n	}\n"
    ]);
    NewHeader_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NewHeader_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	bottom: 0;\n	display: none;\n	width: 100%;\n	height: 100%;\n	background: rgba(0, 0, 0, 0.6);\n	z-index: -1;\n"
    ]);
    NewHeader_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function NewHeader_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	left: 0;\n	top: 50px;\n	opacity: 0;\n	width: 100%;\n	min-height: 450px;\n	height: 450px;\n	background-color: #fff;\n	transform: scaleX(0) scaleY(0);\n	z-index: 10;\n"
    ]);
    NewHeader_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function NewHeader_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding-left: 20px;\n\n	&:first-child {\n		padding-left: 0;\n	}\n\n	> a {\n		position: relative;\n		display: flex;\n		align-items: center;\n		height: 50px;\n		font-size: 15px;\n		color: #555;\n		cursor: pointer;\n\n		&:hover {\n			font-weight: bold;\n			color: #222;\n\n			&:after {\n				position: absolute;\n				bottom: 1px;\n				left: 50%;\n				transform: translateX(-50%);\n				display: block;\n				width: 100%;\n				height: 2px;\n				background-color: #222;\n				height: 2px;\n				content: "";\n			}\n		}\n\n		~ ',
        ":focus-within {\n			opacity: 1;\n			transform: scaleX(1) scaleY(1);\n		}\n	}\n\n	&:hover ",
        " {\n		opacity: 1;\n		transform: scaleX(1) scaleY(1);\n	}\n\n	&:hover ",
        " {\n		display: block;\n	}\n\n	",
        ":hover {\n		display: none;\n	}\n\n	",
        "\n"
    ]);
    NewHeader_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function NewHeader_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 15px;\n	font-size: 14px;\n	color: #777;\n\n	li:hover {\n		color: #4567ad;\n	}\n"
    ]);
    NewHeader_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function NewHeader_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function NewHeader_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: block;\n	font-family: "pr-font-medium";\n	font-size: 18px;\n	color: #4567ad;\n\n	a {\n		margin-left: 7px;\n		color: #111;\n	}\n'
    ]);
    NewHeader_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function NewHeader_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding: 30px;\n	flex-basis: 300px;\n	box-sizing: border-box;\n\n	&:first-child {\n		flex-grow: 1;\n		background-color: #f5f5f5;\n	}\n\n	&:first-child:after {\n		display: none;\n	}\n\n	&:after {\n		position: absolute;\n		right: 0;\n		top: 0;\n		width: 1px;\n		height: 100%;\n		background-color: #ddd;\n		content: "";\n	}\n\n	ul {\n		display: flex;\n		flex-direction: column;\n		gap: 20px;\n		flex-wrap: wrap;\n		height: 340px;\n		width: 100%;\n		margin-top: 20px;\n	}\n\n	li {\n		width: 240px;\n		line-height: 1;\n	}\n'
    ]);
    NewHeader_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function NewHeader_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	li a {\n		display: block;\n		width: 100%;\n		align-items: center;\n		font-size: 15px;\n		color: #555;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		-o-text-overflow: ellipsis;\n		overflow: hidden;\n\n		&:hover {\n			color: #111;\n			text-decoration: underline;\n		}\n	}\n"
    ]);
    NewHeader_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function NewHeader_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	width: 340px;\n	height: 46px;\n	padding: 0 25px 0 20px;\n	border-radius: 30px;\n	border: 2px solid #ffcb31;\n	box-sizing: border-box;\n\n	a {\n		display: block;\n		width: 100%;\n		padding: 12px 0;\n		color: #999;\n		font-size: 15px;\n		",
        "\n	}\n"
    ]);
    NewHeader_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function NewHeader_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 23px;\n	height: 22px;\n	flex-shrink: 0;\n	background: url(https://cimgcdn.ybtour.co.kr/common/button/btn_search.png) no-repeat;\n	z-index: 1;\n"
    ]);
    NewHeader_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function NewHeader_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	width: 100%;\n	height: 30px;\n	background-color: #f3f3f3;\n	box-sizing: border-box;\n	font-size: 13px;\n	color: #555;\n\n	ul {\n		display: flex;\n		gap: 20px;\n		align-items: center;\n		justify-content: end;\n	}\n\n	li:hover {\n		color: #222;\n	}\n\n	a {\n		line-height: 30px;\n	}\n"
    ]);
    NewHeader_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function NewHeader_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 1200px;\n	height: 100%;\n	margin: 0 auto;\n"
    ]);
    NewHeader_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function NewHeader_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-right: 12px;\n	color: #111;\n	cursor: pointer;\n\n	&:after {\n		content: "";\n		position: absolute;\n		top: 50%;\n		right: 0;\n		border-top: 4px solid #222;\n		border-left: 3px solid transparent;\n		border-right: 3px solid transparent;\n		transform: translateY(-50%);\n	}\n\n	',
        "\n"
    ]);
    NewHeader_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 25px;\n	right: -20px;\n	z-index: 1;\n	display: flex;\n	flex-direction: column;\n	gap: 12px;\n	width: 110px;\n	padding: 15px 15px 20px;\n	border: 1px solid #222;\n	border-radius: 3px;\n	background-color: #fff;\n	font-size: 13px;\n	color: #555;\n	box-sizing: border-box;\n\n	&:before {\n		content: "";\n		position: absolute;\n		top: -8px;\n		right: 50%;\n		width: 7px;\n		height: 7px;\n		background: #fff;\n		border-right: 1px solid #222;\n		border-bottom: 1px solid #222;\n		transform: rotate(-135deg) translateX(-50%);\n	}\n\n	a {\n		display: block;\n		line-height: 1;\n\n		&:hover {\n			color: #4567ad;\n			text-decoration: underline;\n		}\n	}\n'
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}





var NewHeader_SkipNavi = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-0"
})(NewHeader_templateObject());
var NewHeader_HeaderWrap = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-e989bba6-1"
})(NewHeader_templateObject1());
var NewHeader_TopBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-2"
})(NewHeader_templateObject2());
var NewHeader_BtnBannerClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e989bba6-3"
})(NewHeader_templateObject3());
var NewHeader_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-4"
})(NewHeader_templateObject4());
var NewHeader_Gnb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-5"
})(NewHeader_templateObject5());
var GnbWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-6"
})(NewHeader_templateObject6());
var NewHeader_TopNavWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-7"
})(NewHeader_templateObject7());
var NewHeader_UtileLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-8"
})(NewHeader_templateObject8());
var NewHeader_BtnGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-9"
})(NewHeader_templateObject9());
var NewHeader_BtnMypage = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e989bba6-10"
})(NewHeader_templateObject10());
var NewHeader_Navi = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-e989bba6-11"
})(NewHeader_templateObject11());
var NewHeader_BtnRecent = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e989bba6-12"
})(NewHeader_templateObject12(), function(props) {
    return props.$hasRecent ? "width: 34px;\n				height: 34px;\n				border: 1px solid #bbb;\n				border-radius: 8px;\n				overflow: hidden;\n\n				img {\n					width: 100%;\n					height: 100%;\n				}\n				" : "\n				width: 36px;\n				height: 36px;\n				border: none;\n				background: url(https://cimgcdn.ybtour.co.kr/common/button/ico_recent.png) center / cover no-repeat;\n			";
});
var NewHeader_GnbItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e989bba6-13"
})(NewHeader_templateObject13(), function(props) {
    return props.$isActive && "\n			color: #222;\n			font-weight:bold;\n	";
});
var NewHeader_IconBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e989bba6-14"
})(NewHeader_templateObject14());
var NewHeader_Lnb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-15"
})(NewHeader_templateObject15());
var NewHeader_LnbWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-16"
})(NewHeader_templateObject16());
var NewHeader_Dim = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-17"
})(NewHeader_templateObject17());
var NewHeader_Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-18"
})(NewHeader_templateObject18());
var NewHeader_LnbItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e989bba6-19"
})(NewHeader_templateObject19(), NewHeader_Category, NewHeader_Category, NewHeader_Dim, NewHeader_Dim, function(props) {
    return props.$isActive && '\n	> a {\n		font-weight: bold;\n		color: #222;\n\n		&:after {\n			position: absolute;\n			bottom: 1px;\n			left: 50%;\n			transform: translateX(-50%);\n			display: block;\n			width: 100%;\n			height: 2px;\n			background-color: #222;\n			height: 2px;\n			content: "";\n			}\n		}\n\n	';
});
var NewHeader_EventNavi = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e989bba6-20"
})(NewHeader_templateObject20());
var NewHeader_CategoryWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-21"
})(NewHeader_templateObject21());
var NewHeader_CategorySubtitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e989bba6-22"
})(NewHeader_templateObject22());
var NewHeader_CategoryArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-23"
})(NewHeader_templateObject23());
var NewHeader_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e989bba6-24"
})(NewHeader_templateObject24());
var NewHeader_SearchWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-25"
})(NewHeader_templateObject25(), (0,desktop_text/* Ellipsis */.mH)(1));
var NewHeader_BtnSearch = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e989bba6-26"
})(NewHeader_templateObject26());
var NewHeader_GnbUtil = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-27"
})(NewHeader_templateObject27());
var NewHeader_GnbUtilWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-28"
})(NewHeader_templateObject28());
var NewHeader_Login = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e989bba6-29"
})(NewHeader_templateObject29(), function(props) {
    return props.$isShow && "\n		&:after {\n			border-top: 0;\n			border-bottom: 4px solid #222;\n		}\n	";
});
var NewHeader_LoginTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e989bba6-30"
})(_templateObject30());
var NewHeader_Header = function() {
    var ref = useState(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var tooltipRef = useRef(null);
    var ref1 = useState(false), isHovered = ref1[0], setIsHovered = ref1[1];
    var loginRef = useRef(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    useEffect(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    // 1 Depth hover시 2 Depth 보여주기
    var handleMouseEnter = function() {
        return setIsHovered(true);
    };
    var handleMouseLeave = function() {
        return setIsHovered(false);
    };
    return /*#__PURE__*/ _jsxs(NewHeader_HeaderWrap, {
        children: [
            /*#__PURE__*/ _jsx(NewHeader_TopBanner, {
                style: {
                    backgroundColor: "#fdebe9"
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner.jpg",
                                alt: "배너 이미지"
                            })
                        }),
                        /*#__PURE__*/ _jsx(NewHeader_BtnBannerClose, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "배너 닫기"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(NewHeader_Container, {
                children: [
                    /*#__PURE__*/ _jsxs(NewHeader_SkipNavi, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "#content",
                                children: "본문 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb",
                                children: "카테고리 메뉴 바로가기"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#gnb-login",
                                children: "로그인 메뉴 바로가기"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(NewHeader_Gnb, {
                        children: [
                            /*#__PURE__*/ _jsxs(GnbWrap, {
                                id: "gnb",
                                children: [
                                    /*#__PURE__*/ _jsxs(NewHeader_TopNavWrap, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h1", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "/index.yb",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png",
                                                                alt: "노랑풍선"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(NewHeader_SearchWrap, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "검색 프로모션 영역 텍스트"
                                                            }),
                                                            /*#__PURE__*/ _jsx(NewHeader_BtnSearch, {
                                                                type: "button",
                                                                onClick: function() {
                                                                    location.href = "https://pkg.ybtour.co.kr/common/searchGoods.yb";
                                                                },
                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                    children: "검색"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(NewHeader_UtileLinks, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("ul", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "베스트"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "마감임박"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "출발보장"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "썸머특가"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    href: "#",
                                                                    children: "당장노랑"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs(NewHeader_BtnGroup, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(NewHeader_BtnMypage, {
                                                                href: "https://pkg.ybtour.co.kr/mypage/index.yb",
                                                                children: /*#__PURE__*/ _jsx(Accessibility, {
                                                                    children: "마이페이지"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs(NewHeader_BtnRecent, {
                                                                href: "#",
                                                                $hasRecent: true,
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Accessibility, {
                                                                        children: "최근본"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Noimage, {
                                                                        width: "32px",
                                                                        height: "32px",
                                                                        src: "https://dimgcdn.ybtour.co.kr/TN/99/99897c62991b42e78a3c3fad024dce69.tn.410x280.jpg",
                                                                        alt: "상품 이미지"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(NewHeader_Navi, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("ul", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            $isActive: isHovered,
                                                            onMouseEnter: handleMouseEnter,
                                                            onMouseLeave: handleMouseLeave,
                                                            children: "해외패키지"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "에어텔"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsxs(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(NewHeader_IconBadge, {
                                                                    children: "NEW"
                                                                }),
                                                                "허니문"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsxs(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(NewHeader_IconBadge, {
                                                                    children: "HOT"
                                                                }),
                                                                "골프"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "크루즈"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "프리미엄"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "국내여행"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "항공"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "호텔"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "투어&티켓"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "렌터카"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx(NewHeader_GnbItem, {
                                                            href: "#",
                                                            children: "기업/단체"
                                                        })
                                                    })
                                                ]
                                            }),
                                            isHovered && /*#__PURE__*/ _jsx(NewHeader_Lnb, {
                                                onMouseEnter: handleMouseEnter,
                                                onMouseLeave: handleMouseLeave,
                                                children: /*#__PURE__*/ _jsxs(NewHeader_LnbWrap, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("ul", {
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    $isActive: isHovered,
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "유럽"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 유럽"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_6"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_7"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_8"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_9"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "6"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가 프로모션 프로모션 프로모션 프로모션"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "아시아나 항공 유럽 SUMMER 특가"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "유럽의 숨겨진 보물, HENANN RESORT"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "상상 이상의 행복한 허니문을 위한 Fourseasons in France"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "절대 놓칠 수 없는 케세이퍼시픽 패밀리 특가"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "동남아"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 동남아"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_6"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_7"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_8"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_9"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_10"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_11"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_12"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_13"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_14"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_15"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_16"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_17"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_18"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "3"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "4"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "5"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "6"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "창립 21주년 기념, 동남아 5만원 할인!"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "격리없이 떠나는 푸켓"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "샹그릴라&요트선셋투어 in 싱가포르"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "동남아! 할인챌린지 앙코르전"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "아시아나 A380 타고 떠나는 방콕/파타야"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "일본"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 일본"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(NewHeader_CategoryArea, {}),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "프로모션"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "오사카 여행 200% 즐기는 방법"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "나만 알고싶은 소도시로, 단풍여행"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "겨울시즌 온천여행 오이타"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "황금연휴 출발확정"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "MZ 취향저격 특급호텔 호캉스 MZ 취향저격 특급호텔 호캉스"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs(NewHeader_LnbItem, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: "#",
                                                                            children: "괌/사이판"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Category, {
                                                                            children: /*#__PURE__*/ _jsxs(NewHeader_CategoryWrap, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_CategorySubtitle, {
                                                                                                children: [
                                                                                                    "지역별",
                                                                                                    /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "[해외패키지] 괌/사이판"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs(NewHeader_List, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_1"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_2"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("li", {
                                                                                                        children: /*#__PURE__*/ _jsx("a", {
                                                                                                            href: "#",
                                                                                                            children: "[나라] 도시_3"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs(NewHeader_CategoryArea, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(NewHeader_CategorySubtitle, {
                                                                                                children: "테마별"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(NewHeader_List, {
                                                                                                children: /*#__PURE__*/ _jsx("li", {
                                                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                                                        href: "#",
                                                                                                        children: "여행에 테마를 더하다"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(NewHeader_CategoryArea, {})
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(NewHeader_Dim, {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "호주/뉴질랜드"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "미주/캐나다/하와이"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "중남미/아프리카"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "대만/홍콩/마카오"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "중국/몽골/중아아시아"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(NewHeader_LnbItem, {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "부산/지방 출발"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(NewHeader_EventNavi, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "기획전"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "이벤트"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("li", {
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        href: "#",
                                                                        children: "홈쇼핑"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(NewHeader_GnbUtil, {
                                id: "gnb-login",
                                children: /*#__PURE__*/ _jsx(NewHeader_GnbUtilWrap, {
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsxs(NewHeader_Login, {
                                                onClick: handleClick,
                                                $isShow: showTooltip,
                                                ref: loginRef,
                                                children: [
                                                    "김노랑 님",
                                                    showTooltip && /*#__PURE__*/ _jsxs(NewHeader_LoginTooltip, {
                                                        ref: tooltipRef,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "개인정보 수정"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "비밀번호 변경"
                                                            }),
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "#",
                                                                children: "SNS 연결 설정"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "#",
                                                    children: "로그아웃"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/mypage/resvInfo.yb",
                                                    children: "예약확인/결제"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    href: "https://pkg.ybtour.co.kr/cs/main.yb",
                                                    children: "고객센터"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

/* harmony default export */ var NewHeader = ((/* unused pure expression or super */ null && (NewHeader_Header)));

// EXTERNAL MODULE: ./framework/utils/logger.ts
var logger = __webpack_require__(42277);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
;// CONCATENATED MODULE: ./hooks/services/queries/bff/global/useGlobalBannerText.ts




/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/banner/text/list`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/ var key = "useGlobalBannerText";
var getPath = function() {
    return "/bff/global/bannerText";
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/banner/text/list`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/ var useGlobalBannerText = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        bnrType: "KEYWORD",
        keyword: ""
    }, options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({
            queryKey: [
                key,
                getPath()
            ],
            queryFn: function() {
                return useConfigureAxios/* default.get */.Z.get(getPath(), {
                    params: params
                }).then(function(r) {
                    return r.data;
                });
            },
            gcTime: Infinity,
            staleTime: Infinity,
            throwOnError: true
        }, options));
    } catch (error) {
        logger/* default.error */.Z.error(error);
    }
};
/* harmony default export */ var global_useGlobalBannerText = (useGlobalBannerText);


;// CONCATENATED MODULE: ./components/layout/header/Desktop/SearchArea.tsx






/**
 * 헤더 검색 영역
 */ var SearchArea = function() {
    var ref;
    var globalBannerTextFetch = global_useGlobalBannerText();
    var globalBannerText = ((ref = globalBannerTextFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var filteredBannerText = (0,react.useMemo)(function() {
        return globalBannerText.filter(function(o) {
            return o.pcYn === "Y";
        });
    }, [
        globalBannerText
    ]);
    var ref1 = (0,react.useState)(null), bannerText = ref1[0], setBannerText = ref1[1];
    (0,react.useEffect)(function() {
        if (filteredBannerText.length > 0) {
            setBannerText(filteredBannerText[Math.floor(Math.random() * filteredBannerText.length)]);
        }
    }, [
        filteredBannerText
    ]);
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_search_keyword", bannerText).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewHeader_SearchWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/searchGoods.yb"),
                children: (bannerText === null || bannerText === void 0 ? void 0 : bannerText.keyword) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader_BtnSearch, {
                type: "button",
                onClick: function() {
                    taggingClick();
                    var url = (bannerText === null || bannerText === void 0 ? void 0 : bannerText.pcUrl) || "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/common/searchGoods.yb");
                    location.href = url;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "검색"
                })
            })
        ]
    });
};
/* harmony default export */ var Desktop_SearchArea = (SearchArea);

;// CONCATENATED MODULE: ./hooks/services/queries/bff/global/useGlobalOpt.ts




/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/ var useGlobalOpt_key = "useGlobalOpt";
var useGlobalOpt_getPath = function() {
    return "/bff/global/opt";
};
/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/ var useGlobalOpt = function(options) {
    try {
        return (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({
            queryKey: [
                useGlobalOpt_key,
                useGlobalOpt_getPath()
            ],
            queryFn: function() {
                return useConfigureAxios/* default.get */.Z.get(useGlobalOpt_getPath()).then(function(r) {
                    return r.data;
                });
            },
            gcTime: Infinity,
            staleTime: Infinity,
            throwOnError: true
        }, options));
    } catch (error) {
        logger/* default.error */.Z.error(error);
    }
};
/* harmony default export */ var global_useGlobalOpt = (useGlobalOpt);


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/layout/header/Desktop/index.tsx















var HeaderComponent = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    /** 로그인 정보 */ var signin = (0,useSigninUser/* default */.ZP)({
        throwOnError: false
    });
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    var custNmKor = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.body.custNmKor) || "";
    var signinCode = ((ref2 = signin.data) === null || ref2 === void 0 ? void 0 : ref2.code) || "9999";
    /** 최근 본 관련 */ var userId = (0,commonUtil/* getCookie */.ej)("userId") || (window.ensureUserHasUniqueId ? window.ensureUserHasUniqueId() : "");
    var recentlyListFetch = (0,useGetRecently/* default */.Z)(userId, webCustNo, {
        enabled: !signin.isFetching && !!userId,
        throwOnError: false
    });
    var recently = ((ref3 = recentlyListFetch.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.productResultList) === null || ref5 === void 0 ? void 0 : ref5.at(0)) || null;
    var ref7 = (0,react.useState)(false), recentlyOpen = ref7[0], setRecentlyOpen = ref7[1];
    var ref8 = (0,react.useState)(false), recentlyShow = ref8[0], setRecentlyShow = ref8[1];
    /** routing 시 최근 본 상품 닫기  */ var handleRouteChange = function() {
        setRecentlyShow(false);
        setRecentlyOpen(false);
    };
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    /** 운영 메뉴 관련 */ var globalOptFetch = global_useGlobalOpt();
    var globalOpt = (ref6 = globalOptFetch.data) === null || ref6 === void 0 ? void 0 : ref6.body;
    /** publish */ var ref9 = (0,react.useState)(false), showTooltip = ref9[0], setShowTooltip = ref9[1];
    var ref10 = (0,react.useState)(false), isDim = ref10[0], setIsisDim = ref10[1];
    var handleDim = function(is) {
        return setIsisDim(is);
    };
    var tooltipRef = (0,react.useRef)(null);
    var loginRef = (0,react.useRef)(null);
    // 로그인시 나오는 툴팁
    var handleClickOutside = function(event) {
        var ref, ref1;
        var target = event.target;
        if (target && !((ref = tooltipRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) && !((ref1 = loginRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(target))) {
            setShowTooltip(false);
        }
    };
    (0,react.useEffect)(function() {
        if (showTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showTooltip
    ]);
    var handleClick = function() {
        setShowTooltip(function(prev) {
            return !prev;
        });
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_icon_main").taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_Recently, {
                open: recentlyOpen,
                show: recentlyShow,
                closeShow: function() {
                    return setRecentlyShow(false);
                },
                closeOpen: function() {
                    return setRecentlyOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkipNavi, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#content",
                                        children: "본문 바로가기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#gnb",
                                        children: "카테고리 메뉴 바로가기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#gnb-login",
                                        children: "로그인 메뉴 바로가기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gnb, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopNavWrap, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "https://cimgcdn.ybtour.co.kr/common/logo/logo_l.png",
                                                                alt: "노랑풍선"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SearchArea, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UtileLinks, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: globalOpt && globalOpt.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: item.pcMenuUrl,
                                                                    target: (0,commonUtil/* getTarget */.U9)(item.webMenuTarget),
                                                                    onClick: function() {
                                                                        return taggingClick(item);
                                                                    },
                                                                    children: item.pcMenuNm
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnGroup, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnMypage, {
                                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/index.yb"),
                                                                onClick: function() {
                                                                    var url = "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/index.yb");
                                                                    if (signinCode !== "0000") LoginUtil.login(url);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Accessibility */.yq, {
                                                                    children: "마이페이지"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnRecent, {
                                                                href: "#",
                                                                $hasRecent: !!recently,
                                                                onClick: function() {
                                                                    setRecentlyOpen(true);
                                                                    setRecentlyShow(true);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* Accessibility */.yq, {
                                                                        children: "최근본"
                                                                    }),
                                                                    (recently === null || recently === void 0 ? void 0 : recently.imgUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: recently.imgUrl,
                                                                        alt: "상품 이미지"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_Gnb, {
                                        handleDim: handleDim
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbUtil, {
                                        id: "gnb-login",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GnbUtilWrap, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    signinCode === "0000" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Login, {
                                                                onClick: handleClick,
                                                                $isShow: showTooltip,
                                                                ref: loginRef,
                                                                children: [
                                                                    custNmKor,
                                                                    " 님",
                                                                    showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginTooltip, {
                                                                        ref: tooltipRef,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/accountPwReaffirmScreen.yb"),
                                                                                children: "개인정보 수정"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/accountPwUpdateScreen.yb"),
                                                                                children: "비밀번호 변경"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/snsConnectionSetup.yb"),
                                                                                children: "SNS 연결 설정"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        LoginUtil.logout();
                                                                    },
                                                                    children: "로그아웃"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#",
                                                                    onClick: function(e) {
                                                                        e.preventDefault();
                                                                        LoginUtil.login();
                                                                    },
                                                                    children: "로그인"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/index.yb"),
                                                                    children: "회원가입"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/mypage/resvInfo.yb"),
                                                            children: "예약확인/결제"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/cs/main.yb"),
                                                            children: "고객센터"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isDim && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dim, {})
                ]
            })
        ]
    });
};
var Desktop_Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Header Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderComponent, {})
    });
};
/* harmony default export */ var Desktop = (Desktop_Header);


/***/ }),

/***/ 15196:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

}]);